<template>
  <g
    id="Front_Wheel-3"
    v-on:click="changeSeverity('leftFrontWheel')"
    :class="severityClass"
  >
    <g>
      <path
        class="cls-456"
        d="M445.51,53.73l-.32-.82c-.15,.06-.3,.13-.45,.22-.06,.04-.12,.07-.18,.11-.28,.2-.54,.44-.76,.73-.47,.61-.79,1.41-.88,2.28-.13,1.28,.17,2.52,.47,3.72l.04,.14c.3,1.22,.55,2.41,.35,3.54-.28,1.6-1.39,2.85-2.56,4.17-.59,.67-1.2,1.35-1.7,2.1-.18,.26-.34,.53-.49,.8-.77,1.43-1.19,3.05-1.21,4.67,.29,.14,.59,.28,.88,.41-.04-1.65,.36-3.32,1.16-4.76,.12-.22,.25-.43,.39-.64,.47-.7,1.06-1.36,1.63-2.01,1.2-1.36,2.44-2.76,2.76-4.6,.23-1.3-.04-2.58-.36-3.9l-.04-.14c-.28-1.13-.56-2.3-.45-3.42,.05-.45,.19-.98,.45-1.45,.17-.31,.39-.59,.66-.81,.05-.04,.11-.08,.16-.12,.13-.09,.28-.17,.44-.23Z"
      />
      <path
        class="cls-456"
        d="M447.64,55.88s-.01-.03-.02-.04c-.05-.14-.11-.27-.18-.41-.23-.49-.49-.95-.8-1.4l-.72,.5c.25,.36,.48,.75,.67,1.15,.02,.04,.04,.07,.05,.11,.03,.05,.05,.1,.07,.16,.95,2.13,1.04,4.61,.21,6.8-.49,1.28-1.24,2.41-2.05,3.6-.51,.76-1.04,1.54-1.48,2.36-.58,1.06-1.01,2.17-1.32,3.32-.43,1.63-.58,3.33-.44,5.02,.31,.12,.61,.24,.92,.35-.18-1.66-.06-3.36,.34-4.98,.29-1.15,.71-2.26,1.27-3.29,.43-.79,.94-1.55,1.44-2.29,.79-1.18,1.62-2.4,2.14-3.78,.87-2.3,.81-4.91-.11-7.18Z"
      />
    </g>
    <path
      class="cls-254"
      d="M462.12,43.63l-.71-2.78-10.05-.53-.6-.03c-.16,.56-.26,1.15-.32,1.74l.79,.04,.31,.02,.26,.02,.83,.04h.25s7.7,.42,7.7,.42l-7.89,5.77-.59,.43c.12,.19,.25,.38,.39,.56-.01,.04-.03,.07-.05,.11-.54,.94-1.74,1.26-2.68,.72-.94-.54-1.26-1.74-.72-2.68,.09-.15,.19-.29,.32-.41l-1.17-4.59c-.2-.19-.36-.42-.47-.68-.22-.57-.17-1.17,.1-1.67l-.72-.04h-.07s-.3-.02-.3-.02c-.32-.17-.67-.28-1.04-.29,0,0-.12-.01-.31-.02-.21-.01-.51-.03-.8-.04-.45-.02-.88-.04-.96-.02-.05,.01-.09,.03-.13,.05-.03,0-.05,0-.07,0-.28,.07-.52,.25-.71,.5-.14,.9-.21,1.82-.21,2.76,0,4.34,1.5,8.33,4.02,11.47,.22,.06,.44,.07,.65,.02,.02,0,.05-.02,.08-.03,.04,0,.08-.01,.12-.02,.18-.04,1.78-1.05,1.78-1.05,.4-.24,.7-.58,.9-.97l.22-.16,1.24-.9h0s.14-.11,.14-.11l1.53-1.11,.34-.25,.71-.51h0s.65-.48,.65-.48h0s7.22-5.27,7.22-5.27Z"
    />
    <g>
      <g>
        <polygon
          class="cls-566"
          points="461.99 44.23 461.29 41.45 448.81 40.79 446.14 40.65 446.04 42.4 449.28 42.57 460.46 43.17 451.16 49.96 448.65 51.79 449.68 53.21 451.39 51.97 461.99 44.23"
        />
        <g class="cls-738">
          <path
            class="cls-253"
            d="M448.91,41.1l.38,1.48-3.24-.17,.09-1.75,2.67,.14c.04,.1,.07,.2,.1,.31Z"
          />
          <path
            class="cls-253"
            d="M451.36,50.76c.1,.41,.11,.82,.02,1.21l-1.71,1.25-1.04-1.42,2.51-1.84,.2,.8Z"
          />
        </g>
      </g>
      <g>
        <path
          class="cls-418"
          d="M444.15,54.45c-1.99-3.8-3.06-8.01-3.12-12.29,0-.5,.4-1.01,.87-1.13,.49-.12,.98-.25,1.47-.37,.47-.12,.96,.17,1.09,.65,1.04,4.09,2.08,8.18,3.12,12.26,.12,.48-.17,.97-.65,1.09-.49,.12-.98,.25-1.47,.37-.47,.12-1.06-.14-1.3-.58Z"
        />
        <path
          class="cls-22"
          d="M447.06,55.11c-1.1,.28-2.42-1.14-2.94-3.18-.26-1.02-.27-2-.08-2.76,.19-.76-.02-1.58-.55-2.16-.53-.58-.99-1.44-1.25-2.46-.52-2.04-.04-3.92,1.06-4.2,.18-.05,2.07,.08,2.07,.08,1.09,.06,2.02,.82,2.29,1.88l2.29,8.99c.27,1.06-.18,2.18-1.12,2.75,0,0-1.6,1.01-1.78,1.06Z"
        />
        <path
          class="cls-717"
          d="M447.25,55.05c-1.1,.28-2.42-1.14-2.94-3.18-.26-1.02-.27-2-.08-2.76,.19-.76-.02-1.58-.55-2.16-.53-.58-.99-1.44-1.25-2.46-.52-2.04-.04-3.92,1.06-4.2,.18-.05,2.07,.08,2.07,.08,1.09,.06,2.02,.82,2.29,1.88l2.29,8.99c.27,1.06-.18,2.18-1.12,2.75,0,0-1.6,1.01-1.78,1.06Z"
        />
        <path
          class="cls-532"
          d="M445.5,41.92c0,.41-.33,.75-.75,.75s-.75-.33-.75-.75,.33-.75,.75-.75,.75,.33,.75,.75Z"
        />
        <path
          class="cls-532"
          d="M448.13,52.86c0,.41-.33,.75-.75,.75s-.75-.33-.75-.75,.33-.75,.75-.75,.75,.33,.75,.75Z"
        />
      </g>
    </g>
    <path
      class="cls-273"
      d="M463.54,44.88c0-.39-.03-.79-.08-1.2-.01-.06-.02-.11-.04-.17,0-.02,0-.04-.01-.06-.27-.99-1.32-1.39-2.28-1.82-.18-.09-.36-.17-.52-.26l-.31,.41-.02,.02-.44,.57s0,0-.01,.01c-.11,.14-.22,.29-.32,.43-.71,.95-1.33,1.94-1.88,2.98l-2.57,4.86-.42,.8-.23,.44-.51,.96-.51,.97-.44,.83-.88,1.66-.37,.7-.07,.13-.32,.6-.39,.72-3.98,7.51-.62,1.17-1.48,2.8-.11,.21-.41,.77-.12,.22-.24,.44-.03,.06-.09,.17-.07,.14-.11,.2-.12,.23-.49,.93-.26-.14c-.27-.14-.59-.05-.75,.2-.02,.02-.02,.03-.03,.04l-.93,1.77-.24,.44-.2,.38-1.08,2.04-.16,.29-.05,.1h0s-.74,1.41-.74,1.41l-3.45,6.51-11.72,22.18-2.2,4.16c-.09,.16,.01,.38,.22,.49l.37,.2-.25,.46-.13,.25-.37-.2c-.21-.11-.44-.06-.53,.1l-.09,.17-1.89,3.55-7.82,14.7c-.24,.46-.07,1.02,.39,1.27l4.65,2.46c.11-.08,.21-.19,.28-.32l9.79-18.42c.09-.16-.01-.38-.21-.49l-.37-.2,.37-.71,.37,.2c.21,.11,.44,.06,.53-.1l14.21-26.87c.45,.2,.9,.39,1.35,.57l3.46-6.55,.61-1.16,.05-.09,.14-.27,.7-1.33,.55-1.03,.2-.39,.18-.35,.85-1.6c.15-.28,.04-.63-.24-.78l-.21-.11s.24-.44,.62-1.16c.04-.07,.07-.15,.12-.22,.04-.07,.07-.14,.11-.21,.02-.05,.05-.09,.07-.14,.03-.06,.06-.11,.09-.17,.01-.02,.02-.04,.03-.05,.08-.14,.16-.29,.24-.45,.04-.07,.08-.15,.12-.22,.13-.25,.27-.5,.41-.77,.04-.07,.07-.14,.11-.21,1.72-3.26,4.03-7.61,4.26-8.05,.12-.23,.25-.47,.37-.7,.11-.21,.22-.42,.33-.63,.41-.77,.81-1.53,1.22-2.3,.31-.58,.62-1.17,.93-1.75,.12-.23,.24-.45,.36-.68,.26-.5,.53-1.01,.8-1.51,.18-.34,.36-.67,.54-1.01,.33-.61,.65-1.23,.97-1.84,.08-.15,.16-.3,.24-.45,.02-.04,.04-.08,.07-.12,.03-.07,.07-.13,.11-.2,.13-.23,.25-.47,.38-.7,.05-.1,.11-.19,.16-.29,.09-.15,.17-.3,.25-.45,.05-.1,.11-.2,.16-.3,.28-.53,.55-1.06,.8-1.61,.27-.59,.51-1.18,.71-1.79,.31-.93,.51-1.88,.55-2.87,.01-.13,.01-.27,.01-.41Z"
    />
    <g>
      <g>
        <g>
          <g>
            <rect
              class="cls-266"
              x="454.31"
              y="13.96"
              width=".3"
              height="21.23"
              transform="translate(59.36 250.48) rotate(-32.86)"
            />
            <rect
              class="cls-717"
              x="448.24"
              y="14.16"
              width=".5"
              height="2.36"
              transform="translate(63.4 245.73) rotate(-32.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="457.28"
              y="13.18"
              width=".3"
              height="21.23"
              transform="translate(29.45 187.01) rotate(-23.85)"
            />
            <rect
              class="cls-717"
              x="452.73"
              y="12.56"
              width=".5"
              height="2.36"
              transform="translate(33.12 184.32) rotate(-23.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="466.38"
              y="13.71"
              width=".3"
              height="21.23"
              transform="translate(2.04 -25.59) rotate(3.15)"
            />
            <rect
              class="cls-717"
              x="466.88"
              y="12.16"
              width=".5"
              height="2.36"
              transform="translate(1.44 -25.67) rotate(3.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="469.24"
              y="14.82"
              width=".3"
              height="21.23"
              transform="translate(15.88 -98.26) rotate(12.15)"
            />
            <rect
              class="cls-717"
              x="471.45"
              y="13.51"
              width=".5"
              height="2.36"
              transform="translate(13.65 -98.94) rotate(12.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="476.3"
              y="20.6"
              width=".3"
              height="21.23"
              transform="translate(126.69 -293.82) rotate(39.15)"
            />
            <rect
              class="cls-717"
              x="483.14"
              y="21.51"
              width=".5"
              height="2.36"
              transform="translate(122.83 -300.08) rotate(39.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="477.95"
              y="23.18"
              width=".3"
              height="21.23"
              transform="translate(184.29 -344.88) rotate(48.15)"
            />
            <rect
              class="cls-717"
              x="486.04"
              y="25.28"
              width=".5"
              height="2.36"
              transform="translate(181.58 -353.45) rotate(48.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="480.26"
              y="32.01"
              width=".3"
              height="21.23"
              transform="translate(398.48 -432.67) rotate(75.15)"
            />
            <rect
              class="cls-717"
              x="490.79"
              y="38.62"
              width=".5"
              height="2.36"
              transform="translate(403.68 -445.04) rotate(75.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="480.09"
              y="35.07"
              width=".3"
              height="21.23"
              transform="translate(476.72 -436.71) rotate(84.15)"
            />
            <rect
              class="cls-717"
              x="490.92"
              y="43.38"
              width=".5"
              height="2.36"
              transform="translate(485.44 -448.6) rotate(84.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="476.77"
              y="43.56"
              width=".3"
              height="21.23"
              transform="translate(699.55 -371.05) rotate(111.15)"
            />
            <rect
              class="cls-717"
              x="486.92"
              y="56.97"
              width=".5"
              height="2.36"
              transform="translate(717.21 -375.22) rotate(111.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="474.83"
              y="45.94"
              width=".3"
              height="21.23"
              transform="translate(762.46 -325.75) rotate(120.15)"
            />
            <rect
              class="cls-717"
              x="484.23"
              y="60.9"
              width=".5"
              height="2.36"
              transform="translate(781.49 -325.7) rotate(120.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="467.15"
              y="50.86"
              width=".3"
              height="21.23"
              transform="translate(893.24 -140.32) rotate(147.15)"
            />
            <rect
              class="cls-717"
              x="473.01"
              y="69.54"
              width=".5"
              height="2.36"
              transform="translate(909.21 -126.59) rotate(147.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="464.19"
              y="51.64"
              width=".3"
              height="21.23"
              transform="translate(914.19 -68.55) rotate(156.15)"
            />
            <rect
              class="cls-717"
              x="468.53"
              y="71.13"
              width=".5"
              height="2.36"
              transform="translate(926.77 -51.08) rotate(156.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="455.08"
              y="51.11"
              width=".3"
              height="21.23"
              transform="translate(906.38 148.37) rotate(-176.85)"
            />
            <rect
              class="cls-717"
              x="454.37"
              y="71.53"
              width=".5"
              height="2.36"
              transform="translate(904.57 170.27) rotate(-176.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="452.22"
              y="50"
              width=".3"
              height="21.23"
              transform="translate(881.84 215.11) rotate(-167.85)"
            />
            <rect
              class="cls-717"
              x="449.81"
              y="70.18"
              width=".5"
              height="2.36"
              transform="translate(875.02 235.84) rotate(-167.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="445.17"
              y="44.22"
              width=".3"
              height="21.23"
              transform="translate(756.07 378.47) rotate(-140.86)"
            />
            <rect
              class="cls-717"
              x="438.12"
              y="62.18"
              width=".5"
              height="2.36"
              transform="translate(738.32 389.27) rotate(-140.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="443.51"
              y="41.64"
              width=".3"
              height="21.23"
              transform="translate(700.75 417.59) rotate(-131.85)"
            />
            <rect
              class="cls-717"
              x="435.22"
              y="58.41"
              width=".5"
              height="2.36"
              transform="translate(681.61 423.73) rotate(-131.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="441.2"
              y="32.81"
              width=".3"
              height="21.23"
              transform="translate(512.48 481.16) rotate(-104.85)"
            />
            <rect
              class="cls-717"
              x="430.47"
              y="45.07"
              width=".5"
              height="2.36"
              transform="translate(496.42 474.43) rotate(-104.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="441.38"
              y="29.75"
              width=".3"
              height="21.23"
              transform="translate(446.38 483.71) rotate(-95.85)"
            />
            <rect
              class="cls-717"
              x="430.33"
              y="40.31"
              width=".5"
              height="2.36"
              transform="translate(433.2 474.06) rotate(-95.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="444.69"
              y="21.26"
              width=".3"
              height="21.23"
              transform="translate(254.64 435.26) rotate(-68.85)"
            />
            <rect
              class="cls-717"
              x="434.33"
              y="26.72"
              width=".5"
              height="2.36"
              transform="translate(251.76 423.15) rotate(-68.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="446.63"
              y="18.88"
              width=".3"
              height="21.23"
              transform="translate(196.86 401.01) rotate(-59.85)"
            />
            <rect
              class="cls-717"
              x="437.02"
              y="22.8"
              width=".5"
              height="2.36"
              transform="translate(196.92 390.06) rotate(-59.85)"
            />
          </g>
        </g>
        <g>
          <g>
            <rect
              class="cls-266"
              x="442.13"
              y="38.39"
              width=".3"
              height="21.23"
              transform="translate(459.13 -395.66) rotate(85.85)"
            />
            <rect
              class="cls-717"
              x="431.06"
              y="48.62"
              width=".5"
              height="2.36"
              transform="translate(449.75 -383.99) rotate(85.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="443.3"
              y="41.22"
              width=".3"
              height="21.23"
              transform="translate(393.03 -391.77) rotate(76.85)"
            />
            <rect
              class="cls-717"
              x="432.48"
              y="53.16"
              width=".5"
              height="2.36"
              transform="translate(387.21 -379.41) rotate(76.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="449.2"
              y="48.18"
              width=".3"
              height="21.23"
              transform="translate(204.54 -322.57) rotate(49.85)"
            />
            <rect
              class="cls-717"
              x="440.69"
              y="64.71"
              width=".5"
              height="2.36"
              transform="translate(206.98 -313.63) rotate(49.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="451.81"
              y="49.79"
              width=".3"
              height="21.23"
              transform="translate(149.6 -280.91) rotate(40.85)"
            />
            <rect
              class="cls-717"
              x="444.51"
              y="67.54"
              width=".5"
              height="2.36"
              transform="translate(153.28 -274.16) rotate(40.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="460.67"
              y="51.95"
              width=".3"
              height="21.23"
              transform="translate(28.37 -108.47) rotate(13.85)"
            />
            <rect
              class="cls-717"
              x="457.93"
              y="72.06"
              width=".5"
              height="2.36"
              transform="translate(30.86 -107.56) rotate(13.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="463.73"
              y="51.72"
              width=".3"
              height="21.23"
              transform="translate(6.92 -38.96) rotate(4.85)"
            />
            <rect
              class="cls-717"
              x="462.69"
              y="72.11"
              width=".5"
              height="2.36"
              transform="translate(7.85 -38.87) rotate(4.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="472.16"
              y="48.25"
              width=".3"
              height="21.23"
              transform="translate(12.67 182.46) rotate(-22.15)"
            />
            <rect
              class="cls-717"
              x="476.21"
              y="67.87"
              width=".5"
              height="2.36"
              transform="translate(9.13 184.75) rotate(-22.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="474.5"
              y="46.27"
              width=".3"
              height="21.23"
              transform="translate(39.02 253.73) rotate(-31.15)"
            />
            <rect
              class="cls-717"
              x="480.09"
              y="65.12"
              width=".5"
              height="2.36"
              transform="translate(34.96 258.02) rotate(-31.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="479.29"
              y="38.51"
              width=".3"
              height="21.23"
              transform="translate(184.73 430.46) rotate(-58.15)"
            />
            <rect
              class="cls-717"
              x="488.53"
              y="53.75"
              width=".5"
              height="2.36"
              transform="translate(184.19 441.12) rotate(-58.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="480.02"
              y="35.53"
              width=".3"
              height="21.23"
              transform="translate(251.2 470.71) rotate(-67.15)"
            />
            <rect
              class="cls-717"
              x="490.05"
              y="49.23"
              width=".5"
              height="2.36"
              transform="translate(253.45 482.66) rotate(-67.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="479.33"
              y="26.43"
              width=".3"
              height="21.23"
              transform="translate(477.18 517.95) rotate(-94.14)"
            />
            <rect
              class="cls-717"
              x="490.2"
              y="35.07"
              width=".5"
              height="2.36"
              transform="translate(489.75 528.04) rotate(-94.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="478.17"
              y="23.6"
              width=".3"
              height="21.23"
              transform="translate(553.82 507.77) rotate(-103.15)"
            />
            <rect
              class="cls-717"
              x="488.77"
              y="30.53"
              width=".5"
              height="2.36"
              transform="translate(569.42 515.12) rotate(-103.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="472.26"
              y="16.64"
              width=".3"
              height="21.23"
              transform="translate(756.16 405.94) rotate(-130.15)"
            />
            <rect
              class="cls-717"
              x="480.57"
              y="18.99"
              width=".5"
              height="2.36"
              transform="translate(775.44 400.68) rotate(-130.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="469.66"
              y="15.03"
              width=".3"
              height="21.23"
              transform="translate(808.39 352.34) rotate(-139.15)"
            />
            <rect
              class="cls-717"
              x="476.75"
              y="16.15"
              width=".5"
              height="2.36"
              transform="translate(826.47 342.44) rotate(-139.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="460.79"
              y="12.87"
              width=".3"
              height="21.23"
              transform="translate(902.85 156.67) rotate(-166.15)"
            />
            <rect
              class="cls-717"
              x="463.32"
              y="11.63"
              width=".5"
              height="2.36"
              transform="translate(910.6 136.22) rotate(-166.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="457.74"
              y="13.1"
              width=".3"
              height="21.23"
              transform="translate(912.13 86.03) rotate(-175.15)"
            />
            <rect
              class="cls-717"
              x="458.56"
              y="11.58"
              width=".5"
              height="2.36"
              transform="translate(914.91 64.26) rotate(-175.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="449.3"
              y="16.57"
              width=".3"
              height="21.23"
              transform="translate(875.96 -117.13) rotate(157.85)"
            />
            <rect
              class="cls-717"
              x="445.05"
              y="15.82"
              width=".5"
              height="2.36"
              transform="translate(864.14 -135.17) rotate(157.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="446.96"
              y="18.55"
              width=".3"
              height="21.23"
              transform="translate(844.85 -177.13) rotate(148.85)"
            />
            <rect
              class="cls-717"
              x="441.17"
              y="18.58"
              width=".5"
              height="2.36"
              transform="translate(829.41 -191.68) rotate(148.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="442.17"
              y="26.31"
              width=".3"
              height="21.23"
              transform="translate(707.09 -319.31) rotate(121.85)"
            />
            <rect
              class="cls-717"
              x="432.73"
              y="29.95"
              width=".5"
              height="2.36"
              transform="translate(687.9 -320.23) rotate(121.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="441.45"
              y="29.29"
              width=".3"
              height="21.23"
              transform="translate(649.84 -351.54) rotate(112.85)"
            />
            <rect
              class="cls-717"
              x="431.21"
              y="34.46"
              width=".5"
              height="2.36"
              transform="translate(631.85 -348.12) rotate(112.85)"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            class="cls-940"
            d="M503.9,43.02c0-.72-.02-1.44-.06-2.16h0c0-.07-.01-.14-.01-.2h0c-.02-.27-.03-.53-.05-.79,0,0,0,.01,0,.02-.16-2.2-.49-4.36-.97-6.46-.01-.06-.03-.13-.04-.19h0s-.02-.08-.03-.12c-.05-.22-.1-.44-.16-.65,0,.01,0,.02,0,.03-.53-2.13-1.22-4.21-2.07-6.2h0c-.03-.07-.05-.13-.08-.2-.1-.24-.2-.48-.31-.72-.89-1.99-1.94-3.91-3.12-5.72h0s-.03-.05-.04-.07c-.01-.02-.02-.04-.03-.05,0-.01-.02-.02-.02-.03h0s0,0,0-.01h0s-.03-.06-.05-.08c-.13-.2-.26-.39-.39-.58h0c-1.23-1.79-2.58-3.5-4.06-5.1-.04-.05-.09-.1-.14-.15-.18-.19-.36-.37-.54-.56-1.51-1.56-3.15-3.01-4.89-4.32-.05-.04-.11-.08-.16-.12-.21-.16-.42-.31-.63-.47,0,0,0,0,0,.01-7.07-5.13-15.76-8.15-25.17-8.15-.72,0-1.44,.03-2.16,.06h0c-.07,0-.13,.01-.2,.01h0c-.26,.02-.51,.03-.77,.05h-.01c-2.2,.16-4.35,.49-6.44,.97-.07,.02-.13,.03-.19,.04h0c-.1,.02-.19,.04-.28,.07-.16,.04-.32,.07-.47,.11h0c-2.13,.54-4.19,1.23-6.18,2.08-.06,.03-.12,.05-.19,.08-.24,.1-.48,.2-.72,.31-1.99,.89-3.89,1.94-5.7,3.11,0,0,0,0-.01,0-.03,.02-.06,.04-.09,.05-.03,.02-.06,.04-.09,.06h0c-.22,.14-.43,.28-.65,.43h.01c-1.8,1.23-3.52,2.58-5.11,4.07-.04,.04-.09,.09-.14,.13t-.01,0c-.19,.18-.38,.36-.56,.54-1.56,1.51-3.01,3.15-4.32,4.89-.04,.05-.07,.1-.11,.15-.02,.02-.03,.04-.05,.06-.14,.19-.28,.39-.42,.58,0,0,.01,0,.02-.01-1.16,1.59-2.2,3.26-3.14,5-.16,.3-.31,.6-.47,.91-.19,.39-.38,.77-.56,1.16-2.56,5.5-3.99,11.63-3.99,18.1,0,.72,.03,1.44,.06,2.16h0c0,.07,0,.14,.01,.2h0c0,.08,0,.15,.01,.22,0,.11,.01,.22,.02,.33,0,.07,.01,.15,.02,.22v.02c.16,2.2,.49,4.35,.97,6.44h0c.01,.06,.03,.13,.04,.19h0s0,.02,0,.03c.06,.25,.12,.49,.18,.73h0c.54,2.13,1.23,4.21,2.08,6.19,.03,.06,.05,.13,.08,.19,.1,.24,.2,.48,.31,.72,.89,1.99,1.94,3.91,3.12,5.72h0s.04,.06,.05,.09c.02,.03,.03,.05,.05,.07,0,0,0,0,0,0,.14,.22,.29,.44,.43,.66h0c1.22,1.8,2.57,3.5,4.06,5.09t0,.01s.09,.09,.13,.13c0,0,0,0,0,0,0,0,0,0,0,0h0c.17,.19,.35,.37,.52,.55h0s0,.01,0,.02c.93,.95,1.9,1.87,2.91,2.72,.37,.33,.76,.64,1.15,.95,.27,.21,.54,.42,.81,.63,0,0,0,0,.01,0h0s.06,.05,.09,.07c.02,.02,.05,.04,.07,.05,.21,.16,.41,.3,.63,.46,0,0,0,0,.01,0,.55,.4,1.1,.78,1.66,1.14,.22,.15,.44,.29,.66,.43,.02,.02,.05,.03,.07,.04,.17,.11,.34,.21,.5,.32,.16,.1,.31,.19,.47,.28,.47,.27,.93,.54,1.4,.79,.26,.14,.53,.27,.79,.41,0,0,0,0,0,0,.06,.03,.12,.06,.18,.09,0,0,0,0,0,0,.66,.33,1.33,.66,2.01,.96,.25,.11,.5,.22,.75,.33,.45,.19,.9,.37,1.36,.55,0,0,0,0,.01,0,.86,.33,1.73,.62,2.62,.89h0c.06,.02,.13,.04,.19,.06,.24,.08,.49,.15,.74,.22,0,0,0-.01,0-.01,2.07,.6,4.21,1.04,6.4,1.31h0c.06,.01,.13,.02,.19,.02h0c.26,.04,.52,.06,.78,.09h0c1.43,.14,2.88,.22,4.34,.22,.73,0,1.45-.02,2.17-.05,.07,0,.13-.01,.2-.01h0c.26-.02,.52-.03,.78-.05,4.38-.32,8.58-1.29,12.5-2.83,.67-.26,1.33-.54,1.98-.84,.71-.32,1.41-.65,2.09-1.01,.34-.18,.67-.36,1.01-.54,.41-.22,.81-.45,1.2-.68,.48-.28,.95-.58,1.42-.88h0c.06-.04,.11-.07,.17-.11,.21-.14,.43-.29,.65-.43,1.8-1.21,3.5-2.58,5.09-4.06t.01-.01s.05-.04,.07-.06,.04-.04,.07-.06h0s0,0,0,0c.19-.18,.38-.36,.56-.54h0c1.56-1.51,3-3.14,4.3-4.88h0c.04-.06,.09-.11,.12-.17,.16-.21,.31-.42,.47-.63,1.27-1.75,2.39-3.61,3.39-5.54l.02-.02c.03-.06,.06-.12,.09-.18,.12-.24,.24-.47,.35-.7,.94-1.94,1.73-3.96,2.38-6.06h0c.02-.06,.04-.13,.05-.19h0c.08-.25,.15-.5,.22-.75,0,0,0,0,0,0,.59-2.07,1.03-4.2,1.29-6.38,0,0,0,0,0-.01,.01-.06,.02-.13,.03-.2h0c0-.06,.01-.13,.02-.19,.02-.18,.04-.36,.06-.54,0-.02,0-.03,0-.05h0c.14-1.44,.22-2.89,.22-4.36Zm-73.2-9.3c3.97-12.9,15.98-22.27,30.18-22.27,17.44,0,31.57,14.13,31.57,31.57,0,8.22-3.15,15.72-8.3,21.34-3.98,4.34-9.17,7.57-15.03,9.14-.35,.1-.71,.19-1.06,.27-.34,.08-.68,.16-1.02,.22-.36,.07-.72,.14-1.08,.19-.71,.12-1.43,.21-2.16,.28-.96,.09-1.93,.13-2.92,.13-2.21,0-4.37-.23-6.45-.66-1.08-.22-2.13-.5-3.17-.83-.01,0-.02,0-.02,0h0c-.33-.1-.65-.21-.96-.33-.02,0-.03-.01-.05-.02-.47-.17-.92-.34-1.38-.53-1.2-.5-2.37-1.06-3.49-1.7-.21-.12-.42-.24-.63-.36-.09-.05-.18-.11-.27-.16-.29-.18-.57-.36-.85-.54-.04-.03-.08-.05-.12-.08-.26-.17-.52-.35-.78-.54-.45-.31-.88-.64-1.31-.97-.31-.24-.61-.49-.91-.74-6.84-5.79-11.18-14.44-11.18-24.1,0-2.23,.23-4.4,.67-6.49,.05-.25,.1-.5,.16-.74,.1-.45,.22-.89,.35-1.33,.06-.25,.13-.49,.21-.73Z"
          />
          <path
            class="cls-717"
            d="M499.56,43.02c0-21.36-17.32-38.68-38.69-38.68-17.54,0-32.36,11.68-37.09,27.68-.07,.24-.14,.49-.21,.73-.12,.44-.24,.89-.34,1.34-.06,.25-.11,.49-.17,.74-.22,1-.39,2.01-.52,3.03,0,0,0,.02,0,.03-.23,1.68-.34,3.39-.34,5.13,0,12.07,5.52,22.85,14.18,29.94,.28,.23,.57,.45,.86,.68,.63,.48,1.26,.94,1.91,1.38,.09,.06,.18,.12,.27,.18,.22,.16,.45,.3,.67,.45,.02,.01,.04,.03,.06,.04,.17,.11,.33,.21,.5,.31,.47,.29,.96,.58,1.44,.85h0c.06,.04,.12,.07,.19,.11,1.04,.58,2.12,1.1,3.22,1.58,.25,.11,.5,.21,.75,.32,.39,.16,.77,.3,1.16,.45,.07,.02,.13,.05,.2,.07,0,0,.01,0,.02,0,.51,.19,1.02,.36,1.54,.52,3.69,1.18,7.62,1.81,11.71,1.81,1.35,0,2.69-.07,4-.2,.83-.09,1.65-.2,2.46-.34,.36-.05,.72-.12,1.08-.19,.34-.07,.68-.14,1.02-.22,.36-.07,.72-.16,1.07-.26,.78-.2,1.56-.42,2.32-.67,.01,0,.02,0,.03-.01,15.5-5.04,26.71-19.61,26.71-36.8Zm-69.71-9.51c4.06-13.27,16.42-22.93,31.02-22.93,17.92,0,32.44,14.53,32.44,32.44,0,15.01-10.19,27.64-24.03,31.34-.35,.1-.71,.19-1.06,.27-.34,.08-.68,.15-1.03,.22-.36,.07-.72,.13-1.08,.19-.8,.13-1.62,.24-2.43,.3-.92,.08-1.86,.12-2.81,.12-2.19,0-4.33-.21-6.41-.63-1.22-.25-2.41-.56-3.57-.93-.01,0-.02,0-.02-.02-.33-.1-.65-.21-.96-.33-.03-.01-.06-.02-.1-.04-.46-.17-.92-.34-1.37-.53-1.18-.49-2.33-1.05-3.44-1.67-.24-.13-.45-.26-.68-.39-.07-.04-.15-.09-.22-.13-.33-.2-.65-.41-.97-.62-.02-.01-.03-.02-.05-.03-.29-.18-.57-.37-.86-.58-.4-.28-.79-.58-1.18-.88-.29-.22-.58-.46-.87-.7-7.17-5.95-11.73-14.92-11.73-24.97,0-2.3,.24-4.54,.69-6.7,.05-.25,.11-.5,.17-.74,.11-.45,.22-.89,.35-1.33,.06-.25,.13-.49,.21-.73Z"
          />
          <path
            class="cls-566"
            d="M499.13,43.02c0-21.12-17.13-38.25-38.26-38.25-17.34,0-31.99,11.54-36.67,27.36-.07,.24-.14,.48-.21,.73-.13,.44-.24,.89-.34,1.34-.06,.25-.12,.5-.17,.74-.57,2.61-.86,5.31-.86,8.08,0,1.78,.12,3.53,.36,5.24,1.34,9.8,6.39,18.41,13.68,24.37,.28,.24,.57,.47,.86,.68,.58,.45,1.18,.89,1.79,1.31l.31,.21c.21,.14,.42,.27,.63,.41,.04,.02,.07,.04,.11,.07,.17,.1,.33,.21,.5,.31,.41,.25,.82,.49,1.24,.73,.13,.07,.26,.14,.39,.21,.03,.02,.05,.04,.09,.05h.01s.03,.02,.03,.03h.01c1.01,.55,2.04,1.06,3.11,1.51,.25,.12,.5,.22,.75,.32,.32,.13,.63,.26,.95,.37h.02s.05,.03,.09,.04h.02s.04,.02,.06,.03c.08,.03,.17,.06,.25,.09,.06,.02,.11,.04,.17,.06,.49,.18,.98,.34,1.48,.5,3.6,1.12,7.43,1.72,11.39,1.72,.35,0,.69,0,1.03-.02,.88-.02,1.75-.07,2.61-.16,.92-.09,1.83-.2,2.73-.36,.36-.06,.72-.12,1.08-.19,.34-.07,.68-.14,1.03-.22,.36-.08,.71-.17,1.06-.26,16.51-4.23,28.72-19.22,28.72-37.05Zm-69.52-9.57c4.09-13.38,16.54-23.12,31.26-23.12,18.05,0,32.69,14.64,32.69,32.69,0,15.13-10.28,27.86-24.23,31.58-.35,.1-.71,.19-1.06,.27-.34,.08-.69,.15-1.03,.22-.35,.07-.71,.13-1.07,.19-.83,.13-1.67,.24-2.51,.31-.92,.07-1.85,.12-2.78,.12-2.19,0-4.34-.22-6.43-.63-1.25-.25-2.47-.57-3.66-.96-.01,0-.02,0-.03-.01h0c-.32-.1-.64-.21-.95-.33-.04-.02-.07-.03-.11-.04-.46-.17-.92-.34-1.37-.54-1.18-.49-2.32-1.04-3.43-1.67-.23-.13-.46-.26-.69-.4-.07-.04-.14-.09-.21-.13-.34-.2-.67-.41-1-.63-.01,0-.02-.01-.03-.02-.29-.19-.59-.39-.88-.59-.39-.28-.78-.56-1.16-.86-.3-.23-.58-.45-.87-.7-7.25-5.99-11.87-15.06-11.87-25.2,0-2.32,.24-4.58,.7-6.76,.05-.25,.1-.5,.16-.74,.11-.45,.22-.89,.35-1.33,.07-.25,.14-.49,.21-.73Z"
          />
        </g>
        <g>
          <path
            class="cls-204"
            d="M494.13,43.03c0-18.36-14.89-33.25-33.25-33.25-14.99,0-27.66,9.92-31.81,23.54-.08,.25-.14,.49-.21,.73-.13,.44-.25,.88-.35,1.33-.06,.25-.11,.49-.16,.74-.48,2.22-.72,4.53-.72,6.9,0,4.02,.72,7.87,2.02,11.43,.07,.2,.15,.4,.23,.6,.04,.1,.08,.19,.12,.29,2.1,5.26,5.5,9.85,9.79,13.38,.28,.23,.57,.46,.86,.68,.37,.29,.74,.56,1.12,.83,.3,.21,.6,.42,.9,.62,0,0,.02,.01,.02,.02,.35,.22,.7,.45,1.06,.66,.06,.04,.12,.07,.19,.11,1.32,.79,2.69,1.48,4.12,2.07,.45,.19,.9,.37,1.36,.54,.37,.14,.74,.27,1.12,.39h0c1.24,.41,2.51,.74,3.82,1,2.1,.42,4.28,.64,6.5,.64,.91,0,1.81-.04,2.71-.11,.91-.07,1.8-.18,2.69-.33,.36-.05,.72-.12,1.08-.19,.34-.07,.68-.14,1.02-.22h0c.32-.08,.64-.16,.95-.24,.04-.01,.07-.02,.11-.03,.18-.05,.36-.09,.54-.14,.21-.06,.43-.12,.65-.19,13.61-4.17,23.5-16.82,23.5-31.79Zm-1.94,1.18c0,.17-.02,.34-.02,.5-.11,2.01-.4,3.96-.87,5.85-.04,.17-.08,.33-.12,.49-.38,1.44-.86,2.83-1.43,4.18-.06,.16-.13,.3-.2,.46-.39,.89-.82,1.75-1.3,2.6-.08,.15-.17,.29-.25,.44-.74,1.27-1.56,2.49-2.48,3.64-.1,.13-.21,.27-.32,.4-1.25,1.53-2.63,2.94-4.14,4.22-.13,.11-.26,.21-.39,.32-1.14,.93-2.34,1.78-3.61,2.54-.14,.09-.29,.17-.43,.26-.83,.48-1.7,.93-2.58,1.34-.16,.07-.31,.14-.47,.21-1.33,.59-2.72,1.1-4.15,1.5-.12,.04-.24,.07-.36,.1-.04,.01-.08,.02-.12,.03-.31,.09-.63,.16-.94,.24-.34,.08-.68,.15-1.02,.22-.36,.07-.72,.13-1.08,.19-.69,.11-1.39,.2-2.09,.27-.24,.02-.48,.04-.71,.06-.17,.01-.34,.02-.5,.03-.57,.04-1.15,.05-1.73,.05-.9,0-1.8-.04-2.69-.12-.17-.01-.34-.03-.5-.04-.97-.1-1.93-.25-2.87-.43-.14-.02-.28-.05-.42-.08-.03,0-.05-.01-.08-.02-1.01-.21-2-.48-2.96-.79,0,0-.01,0-.02,0-.32-.1-.65-.21-.97-.33-.01,0-.02,0-.03-.01-.09-.03-.17-.06-.26-.1-.16-.05-.32-.11-.47-.17-.22-.09-.43-.17-.65-.26-1.2-.49-2.37-1.06-3.5-1.7-.21-.12-.42-.24-.62-.36-.1-.05-.19-.11-.28-.17-.08-.05-.17-.1-.25-.16-.14-.09-.28-.18-.42-.27-.05-.03-.1-.06-.15-.1-.05-.03-.09-.06-.14-.09-.26-.17-.51-.34-.77-.52-.47-.33-.91-.66-1.36-1.01-.32-.25-.62-.5-.92-.76-.06-.06-.13-.11-.2-.17-.13-.11-.25-.22-.38-.33-.72-.65-1.42-1.33-2.07-2.04-.12-.12-.24-.25-.34-.37-.98-1.09-1.89-2.25-2.71-3.48-.1-.14-.19-.28-.28-.42-1.07-1.65-1.99-3.4-2.73-5.25-.06-.16-.13-.31-.19-.47-.53-1.36-.96-2.77-1.29-4.22-.04-.17-.08-.33-.11-.5-.2-.94-.36-1.9-.47-2.87-.03-.17-.04-.34-.06-.5-.11-1.06-.17-2.13-.17-3.22,0-.4,0-.79,.02-1.19,0-.17,.02-.34,.03-.5,.08-1.62,.29-3.21,.62-4.75,.05-.25,.11-.49,.17-.74,.03-.12,.05-.24,.09-.36,.03-.17,.07-.33,.12-.49,.04-.16,.08-.33,.13-.49,.06-.25,.13-.49,.21-.73,.31-1.01,.67-2,1.08-2.96,.06-.16,.13-.31,.2-.47,.39-.89,.82-1.75,1.3-2.6,.07-.15,.16-.29,.25-.44,.74-1.28,1.57-2.49,2.48-3.65,.1-.13,.21-.27,.32-.4,1.25-1.54,2.64-2.95,4.15-4.22,.13-.11,.26-.22,.39-.33,1.14-.93,2.35-1.78,3.61-2.54,.14-.09,.29-.18,.43-.26,.83-.49,1.7-.94,2.58-1.34,.16-.07,.31-.14,.47-.21,1.34-.59,2.72-1.1,4.15-1.5,.16-.05,.33-.09,.49-.13,1.88-.5,3.83-.83,5.83-.97,.17-.02,.34-.03,.51-.03,.57-.03,1.14-.05,1.72-.05,.9,0,1.8,.04,2.69,.11,.17,.02,.33,.03,.5,.05,.97,.1,1.93,.24,2.88,.43,.17,.03,.33,.06,.5,.1,1.46,.31,2.87,.72,4.24,1.23,.16,.06,.32,.12,.47,.18,1.86,.72,3.62,1.6,5.29,2.64,.14,.09,.29,.18,.43,.27,1.24,.8,2.42,1.69,3.53,2.64,.13,.11,.25,.22,.38,.34,.72,.65,1.42,1.33,2.07,2.04,.12,.12,.24,.25,.34,.37,.98,1.09,1.89,2.25,2.71,3.48,.1,.14,.19,.27,.28,.42,1.07,1.64,1.99,3.4,2.73,5.24,.06,.16,.13,.32,.19,.48,.53,1.36,.96,2.77,1.3,4.21,.04,.16,.08,.33,.11,.5,.2,.94,.36,1.9,.48,2.87,.02,.17,.04,.34,.05,.5,.11,1.06,.17,2.14,.17,3.23,0,.4,0,.79-.02,1.18Z"
          />
          <path
            class="cls-717"
            d="M494.47,43.03c0-2.1-.19-4.15-.57-6.14h0c-.02-.13-.04-.26-.07-.37-.02-.12-.05-.25-.07-.37-.02-.07-.03-.15-.05-.22-.03-.16-.07-.32-.11-.48-.05-.24-.11-.47-.17-.7-3.69-14.54-16.87-25.31-32.57-25.31-4.91,0-9.57,1.05-13.78,2.95-.1,.04-.2,.09-.3,.14-.1,.04-.2,.1-.3,.14-.22,.11-.45,.22-.67,.33-.19,.1-.37,.19-.56,.29-7.88,4.13-13.91,11.3-16.54,19.96-.07,.24-.14,.48-.21,.73-.13,.44-.24,.89-.34,1.34-.06,.25-.11,.49-.17,.74-.48,2.25-.73,4.59-.73,6.98,0,10.49,4.8,19.85,12.32,26,.28,.23,.57,.46,.86,.68,.36,.28,.74,.56,1.11,.82,.31,.21,.6,.42,.9,.61,.02,.01,.04,.03,.05,.04,.35,.24,.71,.45,1.07,.67,.06,.03,.11,.06,.17,.1,.33,.19,.65,.37,.98,.56h.02s.02,.02,.02,.02c1,.55,2.04,1.05,3.1,1.49,.39,.17,.78,.32,1.18,.47l.04,.02h.02s.09,.03,.13,.05c.38,.14,.76,.27,1.14,.4,.02,.01,.04,.02,.06,.02,1.25,.41,2.52,.74,3.82,1,2.13,.43,4.33,.65,6.58,.65,.89,0,1.79-.03,2.67-.11,.95-.07,1.88-.19,2.8-.34,.36-.06,.72-.12,1.07-.19,.34-.06,.68-.14,1.03-.22,.35-.08,.71-.17,1.06-.26,14.37-3.81,24.96-16.9,24.96-32.47Zm-2.29,1.18c0,.17-.02,.34-.02,.5-.11,2.01-.4,3.96-.87,5.85-.04,.17-.08,.33-.12,.49-.38,1.44-.86,2.83-1.43,4.18-.06,.16-.13,.3-.2,.46-.39,.89-.82,1.75-1.3,2.6-.08,.15-.17,.29-.25,.44-.74,1.27-1.56,2.49-2.48,3.64-.1,.13-.21,.27-.32,.4-1.25,1.53-2.63,2.94-4.14,4.22-.13,.11-.26,.21-.39,.32-1.14,.93-2.34,1.78-3.61,2.54-.14,.09-.29,.17-.43,.26-.83,.48-1.7,.93-2.58,1.34-.16,.07-.31,.14-.47,.21-1.33,.59-2.72,1.1-4.15,1.5-.12,.04-.24,.07-.36,.1-.04,.01-.08,.02-.12,.03-.31,.09-.63,.16-.94,.24-.34,.08-.68,.15-1.02,.22-.36,.07-.72,.13-1.08,.19-.69,.11-1.39,.2-2.09,.27-.24,.02-.48,.04-.71,.06-.17,.01-.34,.02-.5,.03-.57,.04-1.15,.05-1.73,.05-.9,0-1.8-.04-2.69-.12-.17-.01-.34-.03-.5-.04-.97-.1-1.93-.25-2.87-.43-.14-.02-.28-.05-.42-.08-.03,0-.05-.01-.08-.02-1.01-.21-2-.48-2.96-.79,0,0-.01,0-.02,0-.32-.1-.65-.21-.97-.33-.01,0-.02,0-.03-.01-.09-.03-.17-.06-.26-.1-.16-.05-.32-.11-.47-.17-.22-.09-.43-.17-.65-.26-1.2-.49-2.37-1.06-3.5-1.7-.21-.12-.42-.24-.62-.36-.1-.05-.19-.11-.28-.17-.08-.05-.17-.1-.25-.16-.14-.09-.28-.18-.42-.27-.05-.03-.1-.06-.15-.1-.05-.03-.09-.06-.14-.09-.26-.17-.51-.34-.77-.52-.47-.33-.91-.66-1.36-1.01-.32-.25-.62-.5-.92-.76-.06-.06-.13-.11-.2-.17-.13-.11-.25-.22-.38-.33-.72-.65-1.42-1.33-2.07-2.04-.12-.12-.24-.25-.34-.37-.98-1.09-1.89-2.25-2.71-3.48-.1-.14-.19-.28-.28-.42-1.07-1.65-1.99-3.4-2.73-5.25-.06-.16-.13-.31-.19-.47-.53-1.36-.96-2.77-1.29-4.22-.04-.17-.08-.33-.11-.5-.2-.94-.36-1.9-.47-2.87-.03-.17-.04-.34-.06-.5-.11-1.06-.17-2.13-.17-3.22,0-.4,0-.79,.02-1.19,0-.17,.02-.34,.03-.5,.08-1.62,.29-3.21,.62-4.75,.05-.25,.11-.49,.17-.74,.03-.12,.05-.24,.09-.36,.03-.17,.07-.33,.12-.49,.04-.16,.08-.33,.13-.49,.06-.25,.13-.49,.21-.73,.31-1.01,.67-2,1.08-2.96,.06-.16,.13-.31,.2-.47,.39-.89,.82-1.75,1.3-2.6,.07-.15,.16-.29,.25-.44,.74-1.28,1.57-2.49,2.48-3.65,.1-.13,.21-.27,.32-.4,1.25-1.54,2.64-2.95,4.15-4.22,.13-.11,.26-.22,.39-.33,1.14-.93,2.35-1.78,3.61-2.54,.14-.09,.29-.18,.43-.26,.83-.49,1.7-.94,2.58-1.34,.16-.07,.31-.14,.47-.21,1.34-.59,2.72-1.1,4.15-1.5,.16-.05,.33-.09,.49-.13,1.88-.5,3.83-.83,5.83-.97,.17-.02,.34-.03,.51-.03,.57-.03,1.14-.05,1.72-.05,.9,0,1.8,.04,2.69,.11,.17,.02,.33,.03,.5,.05,.97,.1,1.93,.24,2.88,.43,.17,.03,.33,.06,.5,.1,1.46,.31,2.87,.72,4.24,1.23,.16,.06,.32,.12,.47,.18,1.86,.72,3.62,1.6,5.29,2.64,.14,.09,.29,.18,.43,.27,1.24,.8,2.42,1.69,3.53,2.64,.13,.11,.25,.22,.38,.34,.72,.65,1.42,1.33,2.07,2.04,.12,.12,.24,.25,.34,.37,.98,1.09,1.89,2.25,2.71,3.48,.1,.14,.19,.27,.28,.42,1.07,1.64,1.99,3.4,2.73,5.24,.06,.16,.13,.32,.19,.48,.53,1.36,.96,2.77,1.3,4.21,.04,.16,.08,.33,.11,.5,.2,.94,.36,1.9,.48,2.87,.02,.17,.04,.34,.05,.5,.11,1.06,.17,2.14,.17,3.23,0,.4,0,.79-.02,1.18Z"
          />
          <g class="cls-738">
            <path
              class="cls-253"
              d="M495.07,42.8c0-18.82-15.25-34.08-34.08-34.08-13.31,0-24.84,7.63-30.45,18.76-.01,.01-.01,.03-.02,.04-.9,1.79-1.65,3.67-2.22,5.62-.07,.24-.14,.48-.21,.73-.12,.44-.23,.89-.33,1.34-.06,.25-.11,.49-.16,.74-.45,2.22-.7,4.51-.7,6.85,0,10.66,4.9,20.18,12.57,26.44,.28,.23,.57,.45,.86,.67,.36,.28,.74,.56,1.11,.82,.29,.21,.6,.41,.9,.61,.02,.02,.05,.03,.07,.05,.36,.24,.72,.47,1.09,.68,.05,.03,.11,.06,.16,.09,.09,.05,.17,.11,.26,.16,.12,.07,.25,.14,.38,.21,1.12,.63,2.28,1.2,3.47,1.7,.45,.19,.91,.37,1.37,.55,.09,.03,.19,.07,.28,.1,.14,.05,.28,.1,.42,.14,.15,.06,.3,.11,.45,.16,.05,.02,.1,.04,.16,.05,1.23,.4,2.48,.73,3.76,1,2.19,.44,4.45,.67,6.76,.67,.85,0,1.69-.03,2.53-.1,.97-.07,1.94-.18,2.89-.34,.36-.06,.72-.12,1.07-.19,.34-.06,.68-.13,1.03-.21,.35-.08,.71-.17,1.06-.26,9.51-2.46,17.4-8.92,21.78-17.48,.09-.17,.17-.34,.25-.51,2.23-4.53,3.47-9.62,3.47-15.01Zm-1.63-8.05c.06,.23,.11,.46,.17,.7,.04,.16,.08,.32,.11,.48,.02,.07,.03,.14,.04,.22,.03,.12,.05,.25,.07,.37,.03,.12,.05,.25,.07,.37h0c.34,1.92,.52,3.9,.52,5.92,0,5.29-1.23,10.28-3.41,14.73-.09,.19-.18,.39-.28,.57-.13,.25-.26,.5-.4,.74-4.17,7.63-11.24,13.44-19.72,15.99-.21,.07-.43,.13-.65,.19-.18,.05-.36,.1-.54,.14-.04,.01-.08,.02-.11,.03-.32,.08-.63,.16-.95,.23-.34,.07-.68,.15-1.03,.21-.36,.07-.72,.13-1.08,.19-.88,.14-1.78,.25-2.69,.32-.86,.07-1.72,.1-2.6,.1-2.26,0-4.47-.22-6.6-.66-1.29-.26-2.57-.59-3.8-1h-.02c-.37-.12-.74-.25-1.11-.39-.46-.17-.92-.35-1.37-.54-1.43-.59-2.8-1.28-4.12-2.07-.06-.03-.12-.07-.19-.11-.36-.21-.71-.44-1.05-.66,0,0-.01,0-.02-.01-.31-.2-.61-.4-.91-.62-.38-.27-.75-.54-1.12-.83-.29-.22-.58-.44-.86-.68-4.3-3.52-7.71-8.1-9.82-13.33-.04-.1-.08-.19-.12-.29-.08-.2-.16-.4-.23-.6-1.35-3.63-2.09-7.56-2.09-11.66,0-2.3,.23-4.53,.67-6.7,.05-.25,.1-.5,.16-.74,.1-.45,.21-.89,.34-1.34,.06-.25,.13-.49,.2-.73,.51-1.72,1.16-3.39,1.92-4.99,.1-.19,.19-.37,.28-.57,3.1-6.15,8.06-11.22,14.14-14.45,.18-.1,.37-.19,.56-.29,.22-.11,.44-.22,.67-.33,.1-.05,.2-.1,.3-.14,.1-.05,.2-.1,.3-.14,4.23-1.94,8.94-3.01,13.89-3.01,15.69,0,28.86,10.8,32.46,25.38Z"
            />
          </g>
          <path
            class="cls-485"
            d="M494.96,43.03c0-18.82-15.26-34.08-34.08-34.08-13.22,0-24.69,7.53-30.34,18.53-.01,.01-.01,.03-.02,.04-.91,1.79-1.67,3.66-2.26,5.61-.07,.24-.14,.49-.21,.73-.12,.44-.24,.89-.34,1.34-.06,.25-.11,.49-.17,.74-.49,2.29-.75,4.67-.75,7.1,0,10.65,4.89,20.16,12.54,26.42,.28,.22,.57,.45,.86,.67,.36,.28,.74,.56,1.12,.82,.3,.21,.6,.42,.9,.62,.03,.02,.06,.04,.09,.06,.36,.24,.73,.47,1.1,.69,.05,.03,.1,.06,.14,.09,.09,.05,.18,.11,.27,.16,.13,.07,.25,.14,.39,.22,1.11,.63,2.27,1.19,3.46,1.69,.45,.19,.91,.37,1.37,.54,.1,.04,.2,.07,.29,.11,.14,.05,.28,.1,.42,.14,.15,.06,.3,.11,.45,.16,.09,.04,.18,.06,.27,.09,1.19,.39,2.42,.7,3.67,.95,2.17,.44,4.43,.66,6.74,.66,.88,0,1.75-.03,2.61-.1,1-.07,1.99-.19,2.95-.36,.36-.06,.72-.12,1.08-.19,.34-.06,.68-.14,1.03-.21,.36-.09,.71-.17,1.06-.27,9.52-2.51,17.41-9.04,21.75-17.67,.09-.17,.17-.34,.25-.51,2.15-4.47,3.36-9.48,3.36-14.78Zm-.65,0c0,5.19-1.18,10.11-3.3,14.49-.09,.19-.18,.39-.28,.57-.13,.25-.26,.5-.4,.74-4.32,8.05-11.84,14.12-20.86,16.51-.35,.1-.71,.19-1.06,.27-.34,.08-.68,.15-1.02,.22-.36,.07-.72,.14-1.08,.2-.91,.15-1.82,.26-2.76,.33-.88,.07-1.78,.11-2.69,.11-2.24,0-4.43-.22-6.54-.65-1.3-.25-2.58-.59-3.83-1-.01,0-.02,0-.03,0-.39-.12-.77-.26-1.14-.4-.47-.17-.92-.35-1.37-.54-1.42-.6-2.8-1.29-4.11-2.08-.06-.03-.12-.06-.18-.1-.36-.22-.71-.44-1.06-.67-.01-.01-.03-.02-.04-.03-.3-.19-.6-.4-.9-.6-.38-.27-.75-.54-1.12-.82-.29-.22-.58-.45-.86-.68-7.47-6.13-12.25-15.44-12.25-25.87,0-2.38,.25-4.71,.73-6.95,.05-.25,.1-.49,.16-.74,.11-.45,.22-.89,.35-1.34,.06-.25,.13-.49,.21-.73,.52-1.72,1.18-3.39,1.96-4.98,.1-.19,.19-.37,.28-.57,5.55-10.78,16.79-18.14,29.74-18.14,18.47,0,33.44,14.97,33.44,33.44Z"
          />
        </g>
      </g>
      <g>
        <path
          class="cls-561"
          d="M479.25,43.08v-.06c0-.08,0-.17,0-.25-.02-1.92-.34-3.77-.91-5.5-.03-.1-.06-.19-.1-.29-.27-.78-.59-1.53-.96-2.25-.02-.04-.04-.07-.06-.12-.03-.05-.05-.1-.08-.16-.02-.04-.04-.07-.06-.11-.39-.72-.82-1.42-1.31-2.08-.05-.08-.12-.17-.18-.25-1.12-1.5-2.46-2.81-3.98-3.91-.08-.06-.16-.12-.25-.18-.67-.47-1.36-.89-2.09-1.26-.04-.02-.08-.04-.12-.06-.05-.03-.1-.05-.16-.07-.04-.02-.08-.04-.12-.06-.73-.36-1.49-.67-2.27-.93-.1-.03-.19-.06-.29-.09-1.72-.53-3.55-.82-5.44-.82h-.07c-.11,0-.21,0-.31,.01-.83,.01-1.64,.08-2.43,.21-.04,0-.09,.01-.13,.02-.06,.01-.12,.02-.17,.03-.04,0-.09,.01-.13,.02-.81,.14-1.61,.34-2.38,.59-.1,.03-.19,.06-.29,.1-1.79,.6-3.45,1.48-4.94,2.58-.09,.05-.17,.12-.25,.18-.65,.49-1.27,1.03-1.85,1.61-.04,.03-.06,.06-.09,.09-.04,.04-.09,.08-.12,.12-.03,.03-.06,.06-.09,.1-.57,.58-1.09,1.21-1.57,1.87-.06,.08-.12,.16-.18,.25-.96,1.36-1.74,2.86-2.31,4.46-.06,.18-.12,.35-.18,.53-.02,.06-.04,.13-.06,.19-.01,.04-.02,.07-.03,.1-.12,.41-.23,.82-.32,1.24-.06,.25-.11,.49-.16,.74-.03,.13-.05,.27-.07,.41,0,.04-.02,.09-.02,.13,0,.01,0,.03,0,.04,0,.04-.02,.09-.02,.13-.01,.04-.02,.09-.02,.13-.11,.8-.17,1.62-.17,2.44v.06c0,.08,0,.17,0,.25,.02,1.92,.34,3.77,.91,5.5,.03,.1,.06,.19,.1,.29,.27,.78,.59,1.53,.96,2.25,.02,.04,.04,.08,.06,.12,.02,.05,.05,.1,.08,.15,.02,.04,.04,.08,.06,.12,.39,.72,.82,1.41,1.3,2.07,.06,.09,.12,.17,.18,.25,.12,.16,.25,.32,.37,.48,.93,1.17,2,2.22,3.18,3.12,.14,.11,.28,.21,.42,.32,.08,.06,.16,.12,.25,.18,.17,.12,.35,.24,.53,.36,.51,.33,1.03,.63,1.57,.9,.04,.02,.08,.04,.12,.06,.05,.03,.1,.05,.16,.08,.04,.02,.08,.04,.12,.06,.71,.34,1.44,.64,2.2,.89,.02,.01,.04,.02,.06,.02,.1,.03,.2,.06,.29,.09,.35,.11,.71,.21,1.08,.3,1.4,.34,2.86,.52,4.36,.52h.07c.1,0,.2,0,.31,0,.72-.02,1.43-.07,2.13-.17,.1-.01,.21-.03,.31-.04,.04,0,.09-.01,.13-.02,.06,0,.12-.02,.17-.03,.04,0,.09-.02,.13-.02,.12-.02,.23-.04,.34-.06,.34-.07,.68-.14,1.02-.23,.34-.09,.68-.19,1.02-.29,.01,0,.03,0,.04-.01,.09-.03,.17-.05,.25-.09,1.79-.61,3.45-1.48,4.94-2.58,.09-.06,.17-.12,.25-.19,.65-.49,1.27-1.03,1.85-1.6,.03-.03,.06-.06,.09-.1,.04-.04,.08-.08,.12-.12,.04-.03,.07-.06,.1-.1,.57-.58,1.09-1.21,1.57-1.87,.06-.08,.12-.17,.18-.25,1.07-1.51,1.92-3.19,2.49-4.99,.04-.1,.07-.19,.09-.29,.24-.77,.42-1.57,.56-2.38,0-.04,.01-.09,.02-.13,.01-.06,.02-.12,.03-.18,0-.04,.01-.09,.02-.13,.11-.8,.17-1.61,.17-2.44Zm-2.78,1.34c-.18,.14-.43,.15-.62,0-.12-.09-.2-.22-.21-.36,0-.01-.01-.02,0-.03-.01-.11,.02-.23,.08-.33,0,0,.01,0,.01-.01,.16-.21,.43-.27,.66-.17,.03,.01,.05,.03,.08,.05,.08,.05,.13,.12,.17,.2,.08,.17,.07,.38-.05,.54-.03,.04-.07,.08-.11,.11Zm-30.97-4.32c0,.07-.02,.15-.06,.22,0,.02-.02,.04-.04,.06-.17,.24-.5,.29-.74,.12-.1-.08-.17-.18-.2-.3-.02-.04-.02-.09-.02-.13h0c0-.06,.01-.12,.03-.17,.02-.05,.04-.1,.07-.14,.02-.02,.03-.04,.05-.05,.17-.19,.47-.22,.68-.06,.04,.03,.08,.06,.11,.11,.01,.02,.02,.03,.04,.05,.05,.09,.07,.19,.07,.29Zm-.16,5.2c-.09,.28-.39,.43-.66,.34-.28-.09-.43-.39-.34-.67,.09-.28,.39-.43,.66-.34,.28,.09,.43,.39,.34,.66Zm13.49,10.19c-.41-.7-.33-1.55,.14-2.16,.15-.2,.35-.38,.58-.51,.12-.07,.25-.13,.39-.17,.1-.04,.19-.06,.29-.07,.24-.04,.47-.03,.7,.02,.23,.04,.45,.13,.65,.26,.07,.05,.14,.1,.2,.15,.14,.12,.27,.26,.38,.42,.03,.03,.05,.07,.08,.11,.13,.23,.21,.48,.25,.72h0c.05,.41-.03,.82-.22,1.18-.12,.23-.29,.43-.5,.6-.07,.06-.16,.12-.25,.17,0,0,0,0,0,0-.78,.44-1.74,.3-2.35-.3-.12-.12-.22-.26-.32-.41Zm16.38-16.42c.09-.28,.39-.43,.67-.34,.28,.09,.43,.39,.34,.66-.09,.28-.39,.43-.66,.34-.28-.09-.43-.39-.34-.67Zm-12.41-6.36c-.15,.2-.35,.37-.58,.51-.12,.07-.25,.13-.39,.17-.1,.04-.19,.06-.29,.07-.47,.07-.94-.02-1.34-.27-.23-.14-.43-.33-.59-.57-.03-.03-.05-.07-.07-.11-.13-.23-.21-.48-.25-.72h0c-.09-.67,.18-1.34,.72-1.78,.07-.06,.16-.12,.25-.17,0,0,0,0,0,0,.93-.54,2.13-.22,2.67,.72,.41,.7,.33,1.56-.14,2.17Zm-11.19,6.14h0c-.12,.03-.24,.05-.37,.06-.04,0-.08,0-.12,0-.51,0-.97-.19-1.32-.51-.4-.35-.64-.87-.64-1.44,0-.88,.58-1.63,1.38-1.87,.1-.03,.2-.06,.31-.07,.09-.02,.18-.02,.28-.02,.81,0,1.51,.5,1.8,1.2,.1,.24,.16,.5,.16,.77,0,.43-.14,.82-.37,1.15-.04,.05-.08,.11-.13,.16-.25,.28-.58,.49-.96,.59Zm-2.15,.26c.33-.02,.65,.05,.94,.19,.04,.02,.09,.04,.13,.07,.1,.05,.19,.12,.27,.19,.05,.04,.1,.09,.14,.13,.18,.17,.32,.39,.42,.63,0,0,0,0,0,.01,.03,.09,.06,.17,.08,.26,.03,.1,.04,.19,.05,.29,0,.05,.01,.1,.01,.16,0,.26-.04,.51-.14,.74-.04,.1-.09,.2-.14,.29-.03,.05-.06,.1-.1,.15-.06,.08-.12,.16-.2,.22-.14,.16-.33,.28-.53,.38-.04,.02-.07,.04-.12,.05-.3,.12-.62,.17-.92,.13-.4-.04-.77-.19-1.08-.45-.03-.02-.06-.05-.09-.07-.18-.17-.33-.37-.43-.61-.01-.02-.02-.05-.03-.07-.03-.07-.05-.14-.07-.21-.07-.25-.09-.5-.05-.74,.01-.14,.04-.28,.1-.42,.03-.1,.06-.19,.11-.27,0-.01,.01-.02,.02-.03,.05-.1,.12-.2,.19-.29,.1-.12,.2-.24,.33-.33,.14-.11,.29-.2,.47-.27,.21-.09,.43-.13,.64-.13Zm23.94,7.41c-.13,.11-.29,.2-.46,.27-.54,.21-1.11,.18-1.58-.06-.14-.06-.28-.15-.4-.26-.05-.04-.1-.08-.14-.12-.18-.18-.33-.4-.43-.65-.03-.09-.06-.17-.08-.26-.03-.1-.05-.2-.05-.29-.05-.48,.09-.96,.37-1.34,.05-.08,.12-.16,.2-.22,.14-.16,.33-.28,.53-.38,.04-.02,.07-.04,.11-.05,.3-.12,.62-.17,.93-.13,.4,.04,.78,.2,1.08,.45,.22,.18,.4,.41,.52,.68,.02,.03,.03,.05,.04,.07,.03,.07,.05,.13,.07,.2,.11,.39,.09,.79-.04,1.16-.03,.1-.07,.19-.12,.28-.05,.11-.12,.22-.2,.32-.1,.12-.21,.24-.34,.33Zm-.79,2.55c0,.87-.58,1.62-1.38,1.87-.1,.03-.2,.06-.31,.07-.09,.02-.18,.02-.28,.02-.81,0-1.51-.5-1.8-1.2-.1-.23-.16-.49-.16-.76,0-.43,.14-.82,.37-1.15,.04-.06,.08-.11,.13-.16,.33-.37,.8-.62,1.33-.65,.04,0,.08,0,.12,0,1.08,0,1.96,.88,1.96,1.96Zm-20.54,4.09c-.37-.41-.57-.99-.49-1.58,.02-.11,.04-.22,.08-.32,.2-.64,.73-1.13,1.36-1.3,.16-.04,.33-.06,.51-.06,.09,0,.18,.01,.26,.02,.3,.04,.59,.16,.83,.32,.04,.03,.08,.06,.12,.09,.12,.09,.22,.2,.32,.32,.3,.37,.46,.86,.42,1.36,0,.04-.01,.08-.02,.12-.12,.82-.72,1.44-1.47,1.63-.1,.03-.2,.04-.31,.05-.1,.01-.2,.01-.3,0-.04,0-.09-.01-.13-.02-.48-.07-.89-.3-1.18-.63Zm-1.71-2.79c-.18-.03-.35-.1-.52-.18-.02-.01-.05-.03-.07-.04-.1-.06-.2-.13-.29-.21-.07-.06-.15-.13-.21-.21-.27-.3-.43-.67-.47-1.06-.02-.1-.02-.2-.01-.29,0-.22,.05-.44,.14-.66,.03-.08,.07-.16,.12-.24,.09-.15,.19-.29,.32-.41,.24-.24,.52-.41,.84-.49,.25-.07,.52-.1,.79-.06,.24,.03,.48,.11,.71,.24,.01,0,.02,.01,.03,.02,.08,.04,.15,.1,.22,.15,.39,.29,.64,.72,.73,1.18h0c.01,.09,.02,.16,.03,.24v.05c.02,.32-.05,.64-.2,.94-.01,.04-.03,.07-.05,.11-.03,.06-.07,.12-.12,.17-.11,.15-.24,.28-.38,.39-.45,.35-1.03,.49-1.59,.37Zm19.82-15.91c-.11,.8-.7,1.42-1.44,1.62-.25,.06-.51,.08-.78,.04-.3-.04-.58-.16-.82-.31,0,0,0,0,0,0-.04-.03-.08-.06-.12-.09-.5-.4-.79-1.02-.74-1.69,0-.04,.01-.08,.02-.12,.12-.81,.71-1.44,1.47-1.63,.1-.03,.2-.04,.31-.05,.14-.02,.28-.01,.43,.01,1.07,.15,1.82,1.15,1.67,2.22Zm1.23,1.21c.18,.03,.35,.1,.52,.18,.02,.01,.05,.03,.07,.04,.1,.06,.2,.13,.28,.21,.08,.06,.16,.13,.21,.21,.27,.3,.42,.67,.47,1.06,.02,.1,.02,.19,.01,.29,0,.22-.05,.44-.13,.65-.04,.09-.07,.17-.12,.25-.27,.46-.69,.77-1.17,.9-.25,.07-.51,.09-.78,.06-.24-.03-.49-.11-.71-.23-.01,0-.02-.01-.03-.02-.08-.04-.15-.1-.22-.15-.39-.3-.64-.73-.72-1.19-.02-.1-.03-.19-.03-.29-.01-.32,.05-.64,.2-.94,.01-.04,.03-.07,.05-.11,.03-.06,.07-.12,.12-.17,.11-.16,.24-.28,.38-.39,.45-.35,1.03-.49,1.59-.37Zm3.39,12.58c.24-.17,.56-.12,.74,.12,.17,.24,.12,.56-.12,.74-.24,.17-.57,.12-.74-.12-.17-.23-.12-.56,.12-.73Zm.62,2.91c-.24,.17-.56,.12-.74-.11-.17-.24-.12-.57,.12-.74,.24-.17,.56-.12,.73,.12,.17,.24,.12,.56-.12,.73Zm-9.02,3.86c-.22,.28-.5,.49-.81,.61-.32,.13-.66,.17-1,.12-.03,0-.06,0-.1-.02-.06-.01-.13-.03-.19-.05-.22-.06-.44-.17-.64-.33-.16-.12-.28-.26-.39-.41-.03-.04-.06-.09-.09-.14-.08-.13-.14-.27-.18-.42-.1-.32-.12-.67-.04-1.01,0-.03,.01-.05,.02-.07,.06-.25,.18-.48,.35-.7,.05-.06,.1-.12,.15-.17,.1-.1,.2-.18,.32-.26,.25-.17,.54-.27,.83-.3,.07-.01,.14-.02,.22-.02h.08c.36,.01,.72,.12,1.04,.34,.04,.02,.07,.04,.1,.07,.86,.66,1.01,1.89,.34,2.75Zm-20.85-8.37c.09-.28,.39-.43,.66-.34,.28,.1,.43,.39,.34,.67-.09,.28-.39,.43-.67,.34-.28-.09-.43-.39-.34-.66Zm9.81-15.62c.45-.57,1.15-.82,1.82-.73,.1,.01,.19,.03,.29,.06,.22,.06,.44,.17,.64,.33,.16,.13,.3,.27,.4,.43,.04,.04,.06,.08,.08,.12,.08,.13,.14,.27,.18,.41,.11,.35,.12,.73,.02,1.09-.06,.25-.18,.48-.35,.7-.05,.06-.1,.12-.16,.17-.32,.32-.72,.51-1.14,.57-.1,.01-.2,.02-.3,.02-.36-.01-.73-.12-1.05-.35-.03-.02-.06-.04-.1-.07-.86-.66-1.01-1.89-.34-2.75Zm15.13-.28c.28-.09,.58,.06,.67,.34,.09,.28-.06,.57-.34,.66-.28,.09-.58-.06-.67-.34-.09-.28,.06-.57,.34-.66Zm6.6,9.65c.28,.09,.43,.39,.34,.67-.09,.28-.39,.43-.66,.34-.28-.09-.43-.39-.34-.66,.09-.28,.39-.43,.66-.34Zm.2,5.74c-.01,.05-.04,.1-.07,.14-.17,.23-.5,.28-.73,.11-.06-.04-.11-.1-.14-.16-.05-.09-.07-.19-.07-.29,0-.1,.04-.2,.1-.28,.17-.24,.5-.29,.74-.12,.1,.07,.17,.18,.19,.29,.03,.1,.03,.2-.01,.3Zm-.35,1.61s.04-.09,.07-.13c.03-.04,.06-.08,.11-.11,.18-.14,.44-.15,.63-.01,.17,.12,.25,.34,.21,.53-.02,.07-.04,.14-.09,.21-.02,.02-.03,.04-.05,.05-.18,.19-.48,.22-.69,.06-.19-.13-.26-.39-.18-.6Zm-1.82,5.58h0c-.13,0-.26-.05-.36-.14-.03-.02-.05-.05-.07-.08-.17-.24-.12-.57,.12-.73,.24-.18,.57-.12,.74,.11,.17,.24,.12,.57-.12,.74-.09,.07-.2,.1-.3,.1Zm-2.45,0c-.22,.01-.44-.14-.51-.36-.05-.14-.03-.29,.04-.42,0,0,0-.02,.02-.03,.06-.1,.15-.17,.26-.21,0,0,.01,0,.02,0,.25-.08,.52,.03,.64,.26l.03,.08c.03,.09,.03,.18,.02,.26-.03,.18-.16,.34-.35,.41-.05,.02-.1,.03-.16,.03Zm-1.14,1.59c-.02-.07-.03-.14-.02-.21,0-.1,.04-.19,.11-.27,.06-.08,.14-.14,.25-.18,.27-.09,.57,.06,.66,.34,.04,.12,.03,.25-.01,.36-.03,.09-.1,.18-.18,.23-.04,.03-.09,.06-.14,.07-.28,.09-.57-.06-.66-.34Zm-.43,1.36s.09-.05,.13-.07c.05-.02,.1-.03,.15-.03,.23,0,.44,.13,.52,.36,.06,.2,0,.42-.15,.55-.05,.05-.12,.09-.19,.12-.02,0-.05,.01-.07,.02-.25,.04-.51-.11-.59-.36-.07-.23,.01-.47,.2-.59Zm-2.56-.32c0-.29,.24-.53,.53-.53s.53,.24,.53,.53-.24,.52-.53,.52-.53-.24-.53-.52Zm-1.2,1.66c0-.29,.24-.52,.52-.52s.53,.24,.53,.52-.24,.53-.53,.53-.52-.24-.52-.53Zm-.68,2.19c-.09,0-.18-.03-.26-.07-.02-.01-.04-.03-.06-.04-.1-.07-.18-.18-.2-.3-.01-.03-.02-.07-.02-.11,0-.13,.04-.24,.12-.33,.1-.12,.25-.2,.41-.2,.29,0,.52,.24,.52,.53s-.23,.52-.52,.52Zm-2.28-1.54c-.19-.13-.27-.37-.2-.59,.05-.14,.15-.26,.28-.32,.01,0,.02-.01,.03-.01,.1-.04,.22-.05,.33-.02h0s.01,0,.02,0c.25,.08,.4,.33,.36,.58,0,.03-.01,.06-.02,.09-.03,.09-.07,.16-.13,.22-.01,.01-.03,.03-.04,.04-.13,.1-.31,.14-.48,.08-.05-.02-.1-.04-.14-.07Zm-1.86,.62c.02-.07,.06-.13,.11-.19,.06-.08,.16-.13,.25-.16,.1-.03,.2-.03,.3,0,.28,.09,.43,.39,.34,.66-.04,.12-.12,.22-.22,.28-.06,.04-.14,.07-.22,.07-.02,0-.04,0-.06,0-.05,0-.11-.01-.16-.03-.28-.09-.43-.39-.34-.66Zm-1.66,1.21c.07-.23,.29-.37,.52-.36,.05,0,.1,0,.14,.02,.05,.02,.1,.04,.13,.07,.19,.13,.28,.37,.2,.6-.07,.2-.24,.34-.44,.36-.07,.01-.15,0-.22-.02-.02-.01-.05-.02-.07-.03-.23-.12-.35-.39-.27-.64Zm-1.37-2.13c.17-.24,.5-.28,.73-.12,.24,.17,.29,.5,.12,.74-.17,.24-.5,.29-.74,.11-.23-.17-.28-.5-.11-.73Zm-2.02,1.12c-.06-.16-.04-.34,.07-.49,.07-.11,.18-.17,.29-.2,.14-.04,.3-.01,.44,.08,.24,.18,.28,.5,.12,.74-.17,.24-.5,.29-.74,.12-.09-.07-.16-.16-.18-.26Zm-1.96,.63s-.01-.02-.01-.03c-.03-.11-.03-.24,.03-.34,.01-.03,.03-.06,.05-.1,.06-.09,.15-.15,.25-.18,.16-.06,.34-.04,.49,.06,.24,.17,.29,.5,.12,.74-.17,.24-.5,.28-.74,.12-.09-.07-.16-.17-.18-.27Zm-.76-2.32c-.08-.21,0-.46,.19-.6,.12-.09,.27-.12,.41-.09,.01,0,.02,0,.03,.01,.11,.02,.21,.09,.28,.18,0,0,0,0,.01,.01,.16,.21,.13,.5-.05,.67-.02,.03-.04,.05-.07,.06-.07,.05-.15,.09-.24,.1-.19,.03-.38-.05-.5-.21-.03-.04-.06-.09-.07-.13Zm-1.87,.25s-.08-.06-.11-.11c-.18-.24-.12-.57,.11-.74,.06-.04,.13-.07,.2-.09,.1-.02,.2-.02,.3,.02,.1,.03,.18,.1,.24,.18,.17,.24,.12,.57-.12,.73-.1,.08-.22,.11-.34,.1-.1,0-.2-.04-.28-.11Zm-2.22-.16c-.12-.23-.06-.52,.16-.68,.19-.14,.45-.13,.63,.01,.04,.03,.07,.06,.1,.11,.03,.04,.05,.09,.07,.13,.01,.02,.02,.04,.02,.06,.05,.2-.03,.42-.2,.54-.04,.03-.07,.05-.11,.06-.15,.07-.32,.05-.45-.03-.06-.03-.12-.08-.17-.14-.02-.02-.03-.04-.04-.06Zm.3-2.2c-.15-.05-.28-.17-.34-.34-.09-.28,.06-.57,.34-.66,.17-.05,.35-.02,.48,.09,.08,.06,.14,.14,.18,.25,.09,.28-.06,.57-.34,.66-.11,.04-.22,.03-.33,0Zm-1.95-1.64c.27-.09,.57,.06,.66,.34,.09,.28-.06,.58-.34,.66-.27,.09-.57-.06-.66-.34-.09-.28,.06-.57,.34-.67Zm-2.3-.29c.04-.12,.12-.23,.24-.29,.03-.02,.06-.03,.1-.04,.28-.09,.58,.06,.67,.34,.09,.28-.06,.57-.34,.66-.28,.09-.58-.06-.67-.34-.04-.11-.03-.22,0-.32Zm.75-2.32c.06-.21,.27-.37,.5-.37,.15,0,.28,.06,.38,.17,.01,0,.02,.02,.02,.03,.07,.09,.12,.2,.12,.32v.02c0,.27-.19,.48-.44,.52-.03,.01-.06,.01-.09,.01-.09,0-.17-.02-.25-.06-.17-.09-.28-.26-.28-.47,0-.05,0-.1,.03-.15Zm-1.66-.9s-.03-.1-.03-.16c0-.29,.24-.52,.52-.52,.07,0,.14,.02,.21,.04h0c.09,.04,.17,.11,.22,.19h0c.06,.09,.09,.19,.09,.29,0,.29-.24,.52-.53,.52-.13,0-.24-.04-.33-.12-.08-.06-.14-.15-.17-.25Zm-1.69-1.43c.04-.26,.25-.45,.52-.45,.24,0,.44,.16,.5,.38,.02,.05,.03,.1,.03,.15,0,.05,0,.1-.02,.14-.06,.22-.26,.38-.5,.38-.21,0-.4-.13-.48-.31-.03-.06-.05-.14-.05-.21,0-.03,0-.05,0-.07Zm-.78-5.66c.11-.09,.25-.12,.39-.1h0s.05,.02,.08,.02c.28,.09,.43,.39,.34,.67-.09,.28-.39,.43-.66,.34-.28-.09-.43-.39-.34-.67,.04-.11,.1-.2,.19-.26Zm1.98-1.44c.18-.14,.43-.15,.62,0,.12,.09,.2,.22,.21,.36,.01,.01,.01,.02,0,.03,.01,.11-.02,.23-.09,.33,0,0,0,0,0,.01-.15,.21-.43,.27-.65,.17-.03-.01-.06-.03-.09-.05-.07-.05-.13-.12-.17-.2-.07-.17-.06-.38,.05-.54,.03-.04,.07-.08,.11-.11Zm-1.48-3.6c.02-.07,.04-.14,.09-.21,.02-.02,.03-.04,.05-.05,.18-.19,.47-.22,.69-.06,.1,.07,.16,.17,.19,.27,.04,.1,.03,.22,0,.33-.02,.05-.04,.09-.07,.13-.03,.04-.06,.08-.11,.11-.18,.14-.44,.15-.63,.01-.17-.12-.25-.34-.21-.53Zm2.35-.5c-.07-.21,0-.44,.19-.58,.24-.17,.57-.12,.73,.12,.16,.21,.13,.5-.05,.67-.02,.02-.04,.04-.06,.06-.24,.17-.57,.12-.74-.12-.03-.05-.06-.1-.07-.16Zm.8-1.78c-.24,.17-.56,.12-.73-.12-.17-.24-.12-.56,.11-.73,.24-.17,.57-.12,.74,.12,.17,.24,.12,.56-.12,.74Zm-.31-3.01h0c.12,0,.25,.04,.35,.13,.03,.02,.05,.05,.07,.08,.17,.24,.12,.57-.12,.73-.23,.18-.56,.12-.73-.11-.17-.24-.12-.57,.12-.74,.09-.06,.2-.1,.31-.1Zm2.44,0c.22,0,.44,.14,.51,.36,.05,.14,.03,.29-.04,.42,0,0,0,.02-.02,.03-.06,.1-.15,.17-.27,.21,0,0-.01,0-.02,0-.25,.08-.51-.03-.63-.26-.01-.03-.02-.05-.03-.08-.03-.09-.03-.18-.02-.26,.03-.18,.16-.34,.35-.41,.05-.02,.1-.03,.16-.03Zm1.14-1.59c.02,.07,.03,.14,.02,.21,0,.1-.05,.2-.11,.28-.06,.08-.15,.14-.25,.18-.27,.09-.57-.06-.66-.34-.04-.12-.04-.25,.01-.36,.04-.09,.1-.17,.18-.23,.04-.03,.09-.06,.14-.07,.28-.09,.57,.06,.66,.34Zm.42-1.36s-.08,.05-.13,.06c-.05,.02-.1,.03-.15,.03-.23,0-.44-.13-.52-.36-.06-.2,0-.42,.15-.55,.05-.05,.12-.09,.19-.12,.02,0,.05-.01,.07-.02,.25-.05,.51,.1,.59,.35,.07,.23-.02,.47-.21,.6Zm2.57,.32c0,.29-.24,.53-.53,.53s-.53-.24-.53-.53,.24-.52,.53-.52,.53,.24,.53,.52Zm1.2-1.66c0,.29-.24,.52-.52,.52s-.53-.23-.53-.52,.24-.53,.53-.53,.52,.24,.52,.53Zm1-2.09c.11,.07,.18,.19,.2,.32,0,.03,.01,.06,.01,.1,0,.29-.24,.53-.53,.53s-.52-.24-.52-.53,.23-.52,.52-.52c.12,0,.23,.04,.32,.11Zm1.97,1.43c.19,.13,.27,.37,.2,.59-.05,.14-.15,.26-.28,.32-.01,0-.02,.01-.03,.01-.11,.04-.22,.05-.34,.02,0,0-.01,0-.02,0-.25-.08-.4-.33-.36-.58,0-.03,.01-.06,.02-.09,.03-.09,.07-.16,.13-.22,.13-.13,.34-.18,.52-.12,.05,.02,.1,.04,.14,.07Zm1.86-.62c-.02,.07-.06,.13-.11,.19-.07,.07-.16,.13-.25,.16-.1,.03-.2,.03-.3,0-.28-.09-.43-.39-.34-.67,.04-.12,.12-.22,.22-.28,.09-.05,.18-.08,.28-.08,.05,0,.11,.01,.16,.03,.28,.09,.43,.39,.34,.66Zm1.66-1.21c-.07,.23-.29,.37-.52,.36-.05,0-.1,0-.14-.02-.05-.02-.1-.04-.14-.07-.19-.13-.27-.37-.2-.59,.07-.2,.24-.34,.44-.36,.07-.01,.15,0,.22,.02,.02,.01,.05,.02,.07,.03,.23,.12,.35,.39,.27,.64Zm1.37,2.13c-.17,.24-.5,.29-.73,.12-.24-.17-.29-.5-.12-.74,.18-.23,.5-.29,.74-.11,.24,.17,.29,.5,.12,.73Zm1.95-.64c-.17,.24-.5,.28-.73,.12-.24-.18-.29-.5-.12-.74,.17-.24,.5-.29,.74-.12,.23,.17,.29,.5,.11,.74Zm2.03-1.11c.04,.12,.04,.26-.02,.38-.01,.03-.03,.06-.05,.09-.17,.24-.5,.29-.73,.12-.24-.17-.29-.5-.12-.74,.18-.24,.5-.28,.74-.12,.1,.07,.16,.17,.19,.27Zm.76,2.32c.07,.21,0,.45-.19,.59-.12,.09-.27,.12-.41,.09-.01,0-.02,0-.03,0-.11-.03-.21-.09-.28-.19,0,0,0,0-.01-.01-.16-.21-.13-.5,.05-.67,.02-.03,.04-.05,.07-.06,.07-.05,.15-.09,.23-.1,.19-.03,.39,.05,.5,.21,.03,.04,.06,.09,.07,.14Zm1.88-.25s.07,.06,.11,.11c.18,.24,.12,.57-.11,.74-.06,.04-.13,.07-.2,.09-.1,.03-.2,.02-.3-.02-.1-.03-.18-.1-.24-.18-.17-.24-.12-.57,.12-.73,.1-.08,.22-.11,.34-.1,.1,0,.2,.04,.28,.11Zm2.2,.17c.12,.22,.06,.52-.16,.67-.19,.14-.45,.13-.63-.01-.04-.03-.07-.06-.1-.11-.03-.04-.06-.09-.07-.13-.07-.21,0-.47,.18-.6,.18-.13,.4-.13,.57-.03,.06,.03,.12,.08,.17,.14,.02,.02,.03,.04,.04,.06Zm1.66,3.84c-.28,.09-.57-.06-.66-.34-.09-.27,.06-.58,.34-.66,.27-.09,.57,.06,.66,.34,.09,.28-.06,.58-.34,.67Zm2.3,.28h0c-.04,.13-.13,.24-.25,.3,0,0-.01,0-.01,0-.03,.01-.05,.02-.08,.03-.28,.09-.58-.06-.67-.34-.09-.28,.06-.57,.34-.66,.28-.09,.58,.06,.67,.34,.04,.11,.03,.21,0,.32Zm-.76,2.33c-.06,.22-.26,.38-.5,.38-.15,0-.29-.06-.39-.17,0-.01-.02-.02-.02-.03-.07-.09-.12-.2-.12-.32h0c0-.27,.19-.49,.43-.53,.03-.01,.06-.01,.09-.01,.09,0,.17,.02,.25,.06,.17,.09,.28,.26,.28,.47,0,.05,0,.1-.03,.15Zm1.67,.9s.03,.1,.03,.16c0,.29-.24,.52-.53,.52-.07,0-.14-.02-.2-.04-.1-.04-.18-.11-.24-.19-.05-.09-.09-.18-.09-.29,0-.29,.24-.52,.52-.52,.13,0,.24,.04,.33,.12,.08,.06,.14,.14,.17,.25Zm1.69,1.43c-.04,.26-.25,.45-.52,.45-.24,0-.44-.16-.5-.38-.02-.05-.03-.1-.03-.15,0-.05,0-.1,.02-.14,.06-.22,.27-.38,.51-.38,.21,0,.4,.13,.48,.31,.03,.06,.05,.14,.05,.21,0,.03,0,.05,0,.07Zm.78,5.66h0c-.11,.08-.24,.12-.37,.1-.03,0-.06-.01-.1-.02-.28-.09-.43-.39-.34-.67,.09-.28,.39-.43,.66-.34,.28,.09,.43,.39,.34,.67-.04,.11-.1,.2-.19,.26Z"
        />
        <path
          class="cls-703"
          d="M474.95,43.02c0-1.87-.36-3.65-1.03-5.29-.01-.05-.03-.09-.05-.13-.02-.05-.04-.11-.06-.16-.02-.05-.04-.09-.06-.13-.24-.54-.51-1.06-.81-1.56-.03-.04-.05-.09-.08-.12-.03-.05-.05-.1-.09-.14-.02-.04-.05-.09-.07-.12-1.12-1.73-2.61-3.2-4.37-4.29-.04-.03-.08-.05-.12-.08-.05-.03-.1-.06-.14-.09-.04-.03-.08-.05-.12-.07-.5-.3-1.03-.56-1.57-.79-.04-.02-.09-.04-.13-.05-.05-.03-.11-.05-.16-.06-.04-.02-.09-.04-.13-.05-1.57-.61-3.27-.94-5.06-.94-.34,0-.67,.01-1,.04-.05,0-.1,0-.14,.01-.06,0-.12,0-.17,.02-.05,0-.1,0-.14,.01-.59,.06-1.17,.16-1.73,.29-.04,.01-.09,.02-.13,.03-.05,.01-.11,.03-.17,.04-.05,0-.09,.02-.14,.04-2.03,.54-3.88,1.51-5.44,2.83-.04,.03-.07,.06-.11,.09-.04,.04-.08,.07-.12,.11-.04,.03-.07,.06-.11,.1-.43,.39-.85,.8-1.23,1.25-.03,.04-.06,.07-.1,.11-.03,.04-.07,.09-.11,.13-.03,.04-.06,.07-.09,.11-.91,1.12-1.66,2.39-2.19,3.77-.09,.24-.18,.48-.26,.72-.11,.33-.2,.66-.28,1-.02,.05-.03,.1-.04,.14-.02,.05-.03,.11-.04,.16,0,.01,0,.02,0,.03-.01,.04-.02,.08-.03,.12,0,0,0,.01,0,.02-.04,.2-.08,.41-.11,.61-.06,.36-.11,.73-.14,1.1-.01,.05-.02,.1-.01,.15-.01,.05-.02,.11-.02,.17,0,.05-.01,.1-.01,.14-.02,.25-.02,.5-.02,.75,0,1.87,.36,3.65,1.03,5.29,.02,.05,.03,.09,.05,.13,.02,.05,.04,.1,.06,.16,.02,.04,.04,.09,.06,.13,.24,.54,.51,1.06,.81,1.56,.03,.04,.05,.08,.07,.12,.03,.05,.06,.1,.09,.14,.03,.04,.05,.08,.08,.12,.36,.56,.77,1.1,1.21,1.6,.46,.52,.96,1.02,1.49,1.47,.37,.32,.77,.63,1.18,.9,.16,.11,.33,.22,.49,.32,.04,.03,.08,.05,.12,.07,.05,.03,.1,.06,.14,.09,.04,.03,.09,.05,.13,.07,.5,.3,1.03,.56,1.57,.79,.04,.02,.09,.03,.13,.05,.05,.02,.11,.04,.16,.06,.04,.02,.09,.03,.13,.05,.43,.17,.87,.31,1.31,.43,.49,.13,.98,.25,1.48,.33,.74,.12,1.5,.18,2.27,.18,.34,0,.67-.01,1-.04,.05,0,.1,0,.14-.01,.06,0,.11,0,.17-.02,.05,0,.1,0,.14-.01,.07,0,.15-.02,.22-.03,.37-.04,.73-.1,1.08-.17,.14-.03,.29-.06,.43-.1,.04-.01,.09-.02,.13-.03,.06-.01,.11-.03,.17-.04,.05-.01,.1-.02,.14-.03,.05-.02,.1-.03,.15-.04,.35-.1,.71-.21,1.05-.34,1.56-.57,2.99-1.41,4.24-2.46,.04-.03,.07-.06,.11-.1,.04-.03,.08-.06,.12-.11,.04-.03,.08-.06,.11-.1,.44-.39,.85-.8,1.23-1.25,.04-.03,.07-.07,.1-.11,.04-.04,.07-.09,.11-.13,.03-.04,.06-.07,.09-.11,1.29-1.58,2.24-3.44,2.74-5.48,.01-.04,.02-.09,.03-.14,.02-.05,.03-.11,.04-.17,.02-.05,.03-.09,.03-.14,.12-.57,.21-1.15,.26-1.73,0-.05,.01-.09,.02-.14,0-.06,0-.11,0-.17,0-.05,.01-.1,.01-.14,.02-.25,.02-.5,.02-.75Zm-2.01,3.77c-.54,.21-1.11,.18-1.58-.06-.14-.06-.28-.15-.4-.26-.05-.04-.1-.08-.14-.12-.18-.18-.33-.4-.43-.65-.03-.09-.06-.17-.08-.26-.03-.1-.05-.2-.05-.29-.05-.48,.09-.96,.37-1.34,.05-.08,.12-.16,.2-.22,.14-.16,.33-.28,.53-.38,.04-.02,.07-.04,.11-.05,.3-.12,.62-.17,.93-.13,.4,.04,.78,.2,1.08,.45,.22,.18,.4,.41,.52,.68,.02,.03,.03,.05,.04,.07,.03,.07,.05,.13,.07,.2,.11,.39,.09,.79-.04,1.16-.03,.1-.07,.19-.12,.28-.05,.11-.12,.22-.2,.32-.1,.12-.21,.24-.34,.33-.13,.11-.29,.2-.46,.27Zm-1.71,4.15c-.1,.03-.2,.06-.31,.07-.09,.02-.18,.02-.28,.02-.81,0-1.51-.5-1.8-1.2-.1-.23-.16-.49-.16-.76,0-.43,.14-.82,.37-1.15,.04-.06,.08-.11,.13-.16,.33-.37,.8-.62,1.33-.65,.04,0,.08,0,.12,0,1.08,0,1.96,.88,1.96,1.96,0,.87-.58,1.62-1.38,1.87Zm-6.95,4.74c-.22-.06-.44-.17-.64-.33-.16-.12-.28-.26-.39-.41-.03-.04-.06-.09-.09-.14-.08-.13-.14-.27-.18-.42-.1-.32-.12-.67-.04-1.01,0-.03,.01-.05,.02-.07,.06-.25,.18-.48,.35-.7,.05-.06,.1-.12,.15-.17,.1-.1,.2-.18,.32-.26,.25-.17,.54-.27,.83-.3,.07-.01,.14-.02,.22-.02h.08c.36,.01,.72,.12,1.04,.34,.04,.02,.07,.04,.1,.07,.86,.66,1.01,1.89,.34,2.75-.22,.28-.5,.49-.81,.61-.32,.13-.66,.17-1,.12-.03,0-.06,0-.1-.02-.06-.01-.13-.03-.19-.05Zm-5.32-2.35c.15-.2,.35-.38,.58-.51,.12-.07,.25-.13,.39-.17,.1-.04,.19-.06,.29-.07,.24-.04,.47-.03,.7,.02,.23,.04,.45,.13,.65,.26,.07,.05,.14,.1,.2,.15,.14,.12,.27,.26,.38,.42,.03,.03,.05,.07,.08,.11,.13,.23,.21,.48,.25,.72h0c.05,.41-.03,.82-.22,1.18-.12,.23-.29,.43-.5,.6-.07,.06-.16,.12-.25,.17,0,0,0,0,0,0-.78,.44-1.74,.3-2.35-.3-.12-.12-.22-.26-.32-.41-.41-.7-.33-1.55,.14-2.16Zm-7.38-1.75c.02-.11,.04-.22,.08-.32,.2-.64,.73-1.13,1.36-1.3,.16-.04,.33-.06,.51-.06,.09,0,.18,.01,.26,.02,.3,.04,.59,.16,.83,.32,.04,.03,.08,.06,.12,.09,.12,.09,.22,.2,.32,.32,.3,.37,.46,.86,.42,1.36,0,.04-.01,.08-.02,.12-.12,.82-.72,1.44-1.47,1.63-.1,.03-.2,.04-.31,.05-.1,.01-.2,.01-.3,0-.04,0-.09-.01-.13-.02-.48-.07-.89-.3-1.18-.63-.37-.41-.57-.99-.49-1.58Zm-2.78-2.91c-.02-.1-.02-.2-.01-.29,0-.22,.05-.44,.14-.66,.03-.08,.07-.16,.12-.24,.09-.15,.19-.29,.32-.41,.24-.24,.52-.41,.84-.49,.25-.07,.52-.1,.79-.06,.24,.03,.48,.11,.71,.24,.01,0,.02,.01,.03,.02,.08,.04,.15,.1,.22,.15,.39,.29,.64,.72,.73,1.18h0c.01,.09,.02,.16,.03,.24v.05c.02,.32-.05,.64-.2,.94-.01,.04-.03,.07-.05,.11-.03,.06-.07,.12-.12,.17-.11,.15-.24,.28-.38,.39-.45,.35-1.03,.49-1.59,.37-.18-.03-.35-.1-.52-.18-.02-.01-.05-.03-.07-.04-.1-.06-.2-.13-.29-.21-.07-.06-.15-.13-.21-.21-.27-.3-.43-.67-.47-1.06Zm.65-9.56c.33-.02,.65,.05,.94,.19,.04,.02,.09,.04,.13,.07,.1,.05,.19,.12,.27,.19,.05,.04,.1,.09,.14,.13,.18,.17,.32,.39,.42,.63,0,0,0,0,0,.01,.03,.09,.06,.17,.08,.26,.03,.1,.04,.19,.05,.29,0,.05,.01,.1,.01,.16,0,.26-.04,.51-.14,.74-.04,.1-.09,.2-.14,.29-.03,.05-.06,.1-.1,.15-.06,.08-.12,.16-.2,.22-.14,.16-.33,.28-.53,.38-.04,.02-.07,.04-.12,.05-.3,.12-.62,.17-.92,.13-.4-.04-.77-.19-1.08-.45-.03-.02-.06-.05-.09-.07-.18-.17-.33-.37-.43-.61-.01-.02-.02-.05-.03-.07-.03-.07-.05-.14-.07-.21-.07-.25-.09-.5-.05-.74,.01-.14,.04-.28,.1-.42,.03-.1,.06-.19,.11-.27,0-.01,.01-.02,.02-.03,.05-.1,.12-.2,.19-.29,.1-.12,.2-.24,.33-.33,.14-.11,.29-.2,.47-.27,.21-.09,.43-.13,.64-.13Zm1.06-4.02c.1-.03,.2-.06,.31-.07,.09-.02,.18-.02,.28-.02,.81,0,1.51,.5,1.8,1.2,.1,.24,.16,.5,.16,.77,0,.43-.14,.82-.37,1.15-.04,.05-.08,.11-.13,.16-.25,.28-.58,.49-.96,.59h0c-.12,.03-.24,.05-.37,.06-.04,0-.08,0-.12,0-.51,0-.97-.19-1.32-.51-.4-.35-.64-.87-.64-1.44,0-.88,.58-1.63,1.38-1.87Zm6.95-4.74c.22,.06,.44,.17,.64,.33,.16,.13,.3,.27,.4,.43,.04,.04,.06,.08,.08,.12,.08,.13,.14,.27,.18,.41,.11,.35,.12,.73,.02,1.09-.06,.25-.18,.48-.35,.7-.05,.06-.1,.12-.16,.17-.32,.32-.72,.51-1.14,.57-.1,.01-.2,.02-.3,.02-.36-.01-.73-.12-1.05-.35-.03-.02-.06-.04-.1-.07-.86-.66-1.01-1.89-.34-2.75,.45-.57,1.15-.82,1.82-.73,.1,.01,.19,.03,.29,.06Zm5.32,2.35c-.15,.2-.35,.37-.58,.51-.12,.07-.25,.13-.39,.17-.1,.04-.19,.06-.29,.07-.47,.07-.94-.02-1.34-.27-.23-.14-.43-.33-.59-.57-.03-.03-.05-.07-.07-.11-.13-.23-.21-.48-.25-.72h0c-.09-.67,.18-1.34,.72-1.78,.07-.06,.16-.12,.25-.17,0,0,0,0,0,0,.93-.54,2.13-.22,2.67,.72,.41,.7,.33,1.56-.14,2.17Zm7.38,1.74c-.11,.8-.7,1.42-1.44,1.62-.25,.06-.51,.08-.78,.04-.3-.04-.58-.16-.82-.31,0,0,0,0,0,0-.04-.03-.08-.06-.12-.09-.5-.4-.79-1.02-.74-1.69,0-.04,.01-.08,.02-.12,.12-.81,.71-1.44,1.47-1.63,.1-.03,.2-.04,.31-.05,.14-.02,.28-.01,.43,.01,1.07,.15,1.82,1.15,1.67,2.22Zm2.78,2.91c.02,.1,.02,.19,.01,.29,0,.22-.05,.44-.13,.65-.04,.09-.07,.17-.12,.25-.27,.46-.69,.77-1.17,.9-.25,.07-.51,.09-.78,.06-.24-.03-.49-.11-.71-.23-.01,0-.02-.01-.03-.02-.08-.04-.15-.1-.22-.15-.39-.3-.64-.73-.72-1.19-.02-.1-.03-.19-.03-.29-.01-.32,.05-.64,.2-.94,.01-.04,.03-.07,.05-.11,.03-.06,.07-.12,.12-.17,.11-.16,.24-.28,.38-.39,.45-.35,1.03-.49,1.59-.37,.18,.03,.35,.1,.52,.18,.02,.01,.05,.03,.07,.04,.1,.06,.2,.13,.28,.21,.08,.06,.16,.13,.21,.21,.27,.3,.42,.67,.47,1.06Z"
        />
        <g>
          <path
            class="cls-617"
            d="M471.36,43.02c0-1.23-.21-2.4-.6-3.49-.35-1.02-.87-1.96-1.5-2.81-.17-.22-.34-.43-.52-.64-.71-.8-1.53-1.49-2.46-2.04-1.05-.64-2.23-1.1-3.49-1.32-.62-.12-1.26-.18-1.92-.18-.43,0-.85,.03-1.26,.08-.28,.03-.55,.07-.82,.13-1.06,.21-2.08,.59-3,1.1-1.1,.61-2.08,1.41-2.89,2.36-.66,.77-1.21,1.64-1.62,2.58-.02,.04-.04,.09-.06,.13-.11,.26-.21,.51-.29,.78-.07,.2-.13,.4-.18,.6-.05,.18-.09,.35-.13,.53-.09,.4-.15,.8-.19,1.21-.03,.26-.04,.53-.04,.8,0,.06,0,.13,0,.19,0,1.23,.21,2.4,.6,3.49,.28,.8,.65,1.55,1.11,2.25,.12,.19,.25,.38,.39,.56,.17,.22,.34,.43,.52,.64,.05,.06,.11,.13,.17,.19,.67,.72,1.44,1.35,2.29,1.86,1.05,.64,2.23,1.09,3.49,1.32,.62,.12,1.26,.18,1.91,.18,.43,0,.85-.03,1.27-.08,.27-.03,.54-.07,.79-.12,.01,0,.02,0,.03,0,.71-.14,1.39-.35,2.03-.63,.33-.14,.65-.3,.96-.47,1.1-.61,2.08-1.41,2.89-2.36,.69-.81,1.26-1.72,1.68-2.71,.11-.25,.21-.51,.29-.77,.33-.99,.52-2.04,.54-3.14,0-.06,0-.13,0-.19Z"
          />
          <path
            class="cls-770"
            d="M467.91,49.08c0,.41-.33,.74-.74,.74s-.74-.33-.74-.74,.33-.74,.74-.74,.74,.33,.74,.74Z"
          />
          <path
            class="cls-768"
            d="M464.84,51.42c-.17,.37-.6,.54-.98,.38-.37-.17-.54-.6-.38-.98,.17-.37,.6-.54,.98-.38s.54,.6,.38,.98Z"
          />
          <path
            class="cls-748"
            d="M461.08,52.3c-.3,.27-.77,.25-1.05-.05-.27-.3-.25-.77,.05-1.05,.3-.27,.77-.25,1.05,.05,.27,.3,.25,.77-.05,1.05Z"
          />
          <path
            class="cls-744"
            d="M457.29,51.58c-.39,.13-.81-.09-.93-.48s.09-.81,.48-.93c.39-.13,.81,.09,.93,.48,.13,.39-.09,.81-.48,.93Z"
          />
          <path
            class="cls-749"
            d="M454.12,49.38c-.41-.04-.7-.41-.66-.81,.04-.41,.41-.7,.81-.66,.41,.04,.7,.41,.66,.81-.04,.41-.41,.7-.81,.66Z"
          />
          <path
            class="cls-745"
            d="M452.12,46.09c-.35-.2-.48-.66-.27-1.01,.2-.35,.66-.48,1.01-.27,.35,.2,.48,.66,.27,1.01-.2,.35-.66,.48-1.01,.27Z"
          />
          <path
            class="cls-746"
            d="M451.63,42.26c-.24-.33-.17-.79,.16-1.03,.33-.24,.79-.17,1.03,.16,.24,.33,.17,.79-.16,1.03-.33,.24-.79,.17-1.03-.16Z"
          />
          <path
            class="cls-743"
            d="M452.74,38.56c-.09-.4,.17-.79,.57-.88,.4-.09,.79,.17,.88,.57,.09,.4-.17,.79-.57,.88s-.79-.17-.88-.57Z"
          />
          <path
            class="cls-747"
            d="M455.26,35.64c.09-.4,.48-.66,.88-.57,.4,.09,.66,.48,.57,.88-.09,.4-.48,.66-.88,.57-.4-.09-.66-.48-.57-.88Z"
          />
          <path
            class="cls-742"
            d="M458.75,33.99c.24-.33,.7-.4,1.03-.16,.33,.24,.4,.7,.16,1.03-.24,.33-.7,.4-1.03,.16-.33-.24-.4-.7-.16-1.03Z"
          />
          <path
            class="cls-741"
            d="M462.61,33.91c.35-.2,.81-.08,1.01,.27,.2,.35,.08,.81-.27,1.01-.35,.2-.81,.08-1.01-.27-.2-.35-.08-.81,.27-1.01Z"
          />
          <path
            class="cls-754"
            d="M466.17,35.4c.41-.04,.77,.25,.81,.66s-.25,.77-.66,.81-.77-.25-.81-.66c-.04-.41,.25-.77,.66-.81Z"
          />
          <path
            class="cls-751"
            d="M468.81,38.21c.39,.13,.6,.54,.48,.93-.13,.39-.54,.6-.93,.48s-.6-.54-.48-.93,.54-.6,.93-.48Z"
          />
          <path
            class="cls-739"
            d="M470.08,41.85c.3,.27,.33,.74,.05,1.05-.27,.3-.74,.33-1.05,.05-.3-.27-.33-.74-.05-1.05,.27-.3,.74-.33,1.05-.05Z"
          />
          <path
            class="cls-752"
            d="M469.76,45.7c.17,.37,0,.81-.38,.98-.37,.17-.81,0-.98-.38-.17-.37,0-.81,.38-.98,.37-.17,.81,0,.98,.38Z"
          />
          <g>
            <path
              class="cls-314"
              d="M467.69,49.08c0,.29-.23,.52-.52,.52s-.52-.23-.52-.52,.23-.52,.52-.52,.52,.23,.52,.52Z"
            />
            <path
              class="cls-314"
              d="M464.64,51.33c-.12,.26-.42,.38-.68,.26-.26-.12-.38-.42-.26-.68,.12-.26,.42-.38,.68-.26,.26,.12,.38,.42,.26,.68Z"
            />
            <path
              class="cls-314"
              d="M460.93,52.14c-.21,.19-.54,.17-.73-.04-.19-.21-.17-.54,.04-.73s.54-.17,.73,.04,.17,.54-.04,.73Z"
            />
            <path
              class="cls-314"
              d="M457.22,51.37c-.27,.09-.56-.06-.65-.33-.09-.27,.06-.56,.33-.65,.27-.09,.56,.06,.65,.33,.09,.27-.06,.56-.33,.65Z"
            />
            <path
              class="cls-314"
              d="M454.15,49.16c-.28-.03-.49-.29-.46-.57,.03-.28,.29-.49,.57-.46,.28,.03,.49,.29,.46,.57s-.29,.49-.57,.46Z"
            />
            <path
              class="cls-314"
              d="M452.23,45.89c-.25-.14-.33-.46-.19-.71,.14-.25,.46-.33,.71-.19,.25,.14,.33,.46,.19,.71s-.46,.33-.71,.19Z"
            />
            <path
              class="cls-314"
              d="M451.81,42.13c-.17-.23-.12-.56,.11-.72,.23-.17,.56-.12,.72,.11,.17,.23,.12,.56-.11,.72-.23,.17-.56,.12-.72-.11Z"
            />
            <path
              class="cls-314"
              d="M452.96,38.52c-.06-.28,.12-.56,.4-.62,.28-.06,.56,.12,.62,.4,.06,.28-.12,.56-.4,.62-.28,.06-.56-.12-.62-.4Z"
            />
            <path
              class="cls-314"
              d="M455.48,35.69c.06-.28,.33-.46,.62-.4,.28,.06,.46,.33,.4,.62-.06,.28-.33,.46-.62,.4-.28-.06-.46-.33-.4-.62Z"
            />
            <path
              class="cls-314"
              d="M458.93,34.12c.17-.23,.49-.28,.72-.11,.23,.17,.28,.49,.11,.72-.17,.23-.49,.28-.72,.11-.23-.17-.28-.49-.11-.72Z"
            />
            <path
              class="cls-314"
              d="M462.72,34.1c.25-.14,.57-.06,.71,.19,.14,.25,.06,.57-.19,.71-.25,.14-.57,.06-.71-.19-.14-.25-.06-.57,.19-.71Z"
            />
            <path
              class="cls-314"
              d="M466.19,35.62c.28-.03,.54,.18,.57,.46,.03,.28-.18,.54-.46,.57-.28,.03-.54-.18-.57-.46-.03-.28,.18-.54,.46-.57Z"
            />
            <path
              class="cls-314"
              d="M468.74,38.42c.27,.09,.42,.38,.33,.65-.09,.27-.38,.42-.65,.33-.27-.09-.42-.38-.33-.65,.09-.27,.38-.42,.65-.33Z"
            />
            <path
              class="cls-314"
              d="M469.93,42.02c.21,.19,.23,.52,.04,.73-.19,.21-.52,.23-.73,.04s-.23-.52-.04-.73c.19-.21,.52-.23,.73-.04Z"
            />
            <path
              class="cls-314"
              d="M469.56,45.79c.12,.26,0,.57-.26,.68-.26,.12-.57,0-.68-.26s0-.57,.26-.68c.26-.12,.57,0,.68,.26Z"
            />
          </g>
        </g>
      </g>
      <g class="cls-738">
        <path
          class="cls-109"
          d="M462.96,53.3c.71-.14,1.39-.35,2.03-.63l-.16-.81-.06-.33-.09-.45v-.02s-.02-.1-.02-.1v-.02s-.1-.45-.1-.45l-1.43-7.24-1.91,1.39,1.72,8.67v.07s.02-.05,.03-.07Z"
        />
        <path
          class="cls-109"
          d="M466.54,60.51l-.15-.75-.16-.79-.54-2.71-.12-.62c-.63,.25-1.36,.17-1.93-.27-.16-.12-.28-.26-.39-.41l.37,1.89,.83,4.21c.71-.14,1.4-.32,2.08-.54Z"
        />
        <path
          class="cls-109"
          d="M471.23,84.19l-.73-3.69-.09-.42-.81-4.09-.04-.19-.05-.29-.03-.16-.04-.19-.11-.55-.05-.25-.17-.86-.05-.24c-.68,.19-1.38,.35-2.09,.49l.05,.24,.17,.86,.05,.25,.11,.54h0s.04,.2,.04,.2l.03,.15,.05,.28,.04,.2,.81,4.09,.09,.42,.65,3.29h0s.06,.3,.06,.3v.04s.09-.02,.09-.02l.64-.13h0l1.38-.27Z"
        />
        <path
          class="cls-109"
          d="M430.93,33.78l-.24-.06-.85-.21-.24-.06-.55-.13-.14-.03h-.04s-.16-.05-.16-.05l-.43-.11h-.04s-4.05-1.01-4.05-1.01l-.42-.11-2.84-.7-.51,2.08,1.06,.26h0l.11,.03,.32,.08,1.31,.32,.42,.1,4.05,1,.06,.02,.42,.1,.15,.04h.06s.12,.04,.12,.04l.54,.13,.24,.06,.85,.21,.24,.06c.16-.7,.35-1.39,.56-2.07Z"
        />
        <path
          class="cls-109"
          d="M461.57,41.31l-9.96-2.45h0l-.31-.07s-.04,.09-.06,.13c-.04,0-.08,0-.12,0-.51,0-.97-.19-1.32-.51l-2.03-.5-.73-.18-.87-.21-2.59-.64c-.24,.67-.44,1.36-.59,2.06l4.17,1.02,.68,.17,2.8,.68,.88,.22,.42,.1,.88,.21h0l6.5,1.6,2.26-1.65Z"
        />
      </g>
      <g>
        <polygon
          class="cls-526"
          points="462.12 43.78 470.22 84.73 468.12 85.14 460.21 45.17 462.12 43.78"
        />
        <polygon
          class="cls-526"
          points="458.3 43.49 419.43 33.94 419.94 31.86 460.56 41.84 458.3 43.49"
        />
      </g>
      <path
        class="cls-533"
        d="M482.81,80.04l-1.46-.65h-.01s-.2-.1-.2-.1l-.68-.3-.6-.27c-1.06-.48-2.27-.51-3.37-.09-1.19,.45-2.41,.86-3.64,1.19-.01,0-.02,.01-.03,.01-3.54,.97-7.21,1.47-10.92,1.43-6.2-.04-12.48-1.54-18.34-4.64-11.31-5.99-18.55-16.66-20.59-28.36-.59-3.4-.75-6.89-.44-10.37,0-.01,0-.02,0-.03,.31-3.5,1.09-6.99,2.37-10.4,.18-.48,.14-1-.09-1.46-.47-.91-1.02-1.8-1.59-2.64-.05-.08-.1-.16-.16-.24-.01-.02-.03-.04-.05-.06,0,0,0,0,0,0-.05-.07-.1-.14-.16-.21-.16,.3-.31,.6-.47,.91-2.91,5.79-4.55,12.33-4.55,19.26,0,.72,.03,1.44,.06,2.16t0,.01c0,.07,.01,.13,.01,.2h0c0,.07,0,.14,.02,.21,0,.11,.01,.22,.02,.33,0,.08,.01,.16,.02,.24,0,0,0-.01,0-.02v.02c.16,2.2,.49,4.35,.97,6.44h0c.01,.06,.03,.13,.04,.19h0s0,.02,0,.03c.06,.25,.12,.49,.18,.73h0c.54,2.13,1.23,4.21,2.08,6.19,.03,.06,.05,.13,.08,.19,.1,.24,.2,.48,.31,.72,.89,1.99,1.94,3.91,3.12,5.72h0s.04,.06,.05,.09c.02,.03,.04,.05,.05,.09h0c.14,.21,.29,.43,.43,.65h0c1.22,1.8,2.57,3.5,4.06,5.09t0,.01s.09,.09,.13,.13c0,0,0,0,0,0h0s0,.01,0,.01c.17,.19,.35,.37,.52,.55h0s0,.01,0,.02c.93,.95,1.9,1.87,2.91,2.72,.37,.33,.76,.64,1.15,.95,.27,.21,.54,.42,.81,.63,0,0,0,.01,.01,.02,.03,.02,.06,.04,.09,.06,.02,.02,.05,.04,.07,.05,.21,.16,.41,.3,.63,.46,0,0,0,0,.01,0,.75,.55,1.54,1.07,2.33,1.57,.35,.22,.69,.43,1.04,.64,.47,.27,.93,.54,1.4,.79,1.65,.89,3.36,1.67,5.13,2.34,.86,.33,1.73,.62,2.62,.89h0c.06,.02,.13,.04,.19,.06,.24,.08,.49,.15,.74,.22,0,0,0-.01,0-.01,2.07,.6,4.21,1.04,6.4,1.31h0c.06,.01,.13,.02,.2,.03,0,0,0,0,0,0,.26,.04,.52,.06,.78,.09h0c1.43,.14,2.88,.22,4.34,.22,.73,0,1.45-.02,2.17-.05,.07,0,.13-.01,.2-.01h0c.26-.02,.52-.03,.78-.05,4.38-.32,8.58-1.29,12.5-2.83,.67-.26,1.33-.54,1.98-.84,1.06-.47,2.09-.99,3.1-1.55,.41-.22,.81-.45,1.2-.68Z"
      />
      <path
        class="cls-315"
        d="M486.92,84.09l-6.32-2.82-2.1-.94c-1.06-.48-2.27-.51-3.36-.09-1.02,.39-2.06,.74-3.11,1.04-.1,.03-.2,.06-.29,.09-.02,0-.04,.01-.05,.02h0c-.32,.09-.63,.18-.95,.26-.36,.09-.71,.18-1.07,.26-.34,.07-.68,.15-1.02,.21-.35,.07-.72,.14-1.08,.2-.78,.13-1.55,.25-2.33,.33-.11,.01-.21,.02-.31,.03-.02,0-.04,0-.06,0-2.18,.22-4.38,.26-6.58,.12-.1,0-.21-.01-.31-.02-.02,0-.04,0-.06,0-2.17-.16-4.34-.5-6.49-1.02-.1-.03-.2-.05-.3-.08-.02,0-.04,0-.06-.02-1.33-.34-2.66-.75-3.97-1.24-.46-.17-.91-.34-1.37-.54-.25-.1-.5-.21-.75-.32-.05-.02-.09-.04-.14-.06-.09-.04-.18-.07-.27-.12-.02-.01-.04-.02-.06-.03-.77-.35-1.52-.72-2.28-1.12-.72-.38-1.42-.78-2.11-1.21-.17-.1-.34-.2-.5-.3-.25-.16-.49-.32-.73-.48-.04-.02-.08-.04-.12-.07-.09-.05-.17-.11-.26-.17-.02-.01-.04-.02-.05-.04-1.84-1.25-3.55-2.63-5.12-4.13h0c-.07-.07-.15-.14-.22-.21-.02-.02-.03-.03-.04-.04-1.58-1.54-3.02-3.2-4.3-4.95-.07-.09-.13-.18-.19-.26-.01-.02-.03-.03-.04-.05-1.28-1.79-2.41-3.68-3.38-5.64-.04-.09-.09-.18-.13-.28-.01-.02-.02-.04-.03-.06-.95-1.98-1.74-4.03-2.35-6.14-.03-.1-.06-.19-.08-.29-.01-.02-.02-.04-.02-.06-.59-2.11-1.02-4.26-1.25-6.45-.02-.1-.03-.2-.04-.31,0-.02,0-.04,0-.06-.22-2.17-.27-4.37-.12-6.57,.01-.1,.02-.21,.03-.32,0-.02,0-.04,0-.06,.13-1.84,.4-3.68,.8-5.51,.05-.25,.11-.49,.17-.74,.02-.08,.04-.17,.06-.25,.02-.1,.05-.2,.07-.3,0-.02,0-.04,.02-.05,.06-.25,.12-.49,.19-.73,.06-.25,.13-.49,.21-.73,.26-.9,.56-1.79,.89-2.68,.18-.48,.15-1-.09-1.46,0-.01-.01-.03-.02-.04-.04-.08-.09-.16-.13-.24-.01-.03-.03-.05-.04-.08-.44-.81-.93-1.59-1.43-2.33-1.79-2.6-3.82-4.7-4.72-5.59-.11-.1-.23-.15-.36-.15-.28,0-.47,.36-.5,.43-12.28,23.4-4.34,52.08,17.66,65.98,.25,.16,.49,.3,.74,.45,.17,.11,.34,.21,.51,.3,.69,.41,1.4,.81,2.11,1.19,.9,.48,1.82,.93,2.74,1.35l.75,.34c.45,.2,.9,.39,1.35,.57,15.07,6.06,31.7,4.31,44.93-3.71,.78-.48,.7-1.64-.13-2.01Z"
      />
    </g>
    <g>
      <path
        class="cls-880"
        d="M463.44,43.47l-.03-.02-.27-.14-.06-.03-2.45-1.3-.16-.08-.2-.11-.07-.04-1.14-.6-.21,.27-.56,.72c-.12,.16-.25,.32-.35,.48-.17,.22-.32,.44-.47,.66-.51,.74-.97,1.5-1.39,2.28l-1.36,2.56-.11,.22-.43,.81-.11,.2-.29,.55-.29,.55-1.43,2.7-.3,.57-.34,.65-.48,.91-1.22,2.31-.65,1.22-.37,.7-5.1,9.64-.11,.21-.41,.77-.12,.22-.24,.44-.03,.06-.09,.16-.07,.14-.11,.21-.12,.22-.79,1.49-.94,1.77-.24,.44-.2,.38-.55,1.03-.35,.67-.16,.3-.05,.1h0s-.93,1.74-.93,1.74l-3.45,6.52-11.91,22.48-2.45,4.62-.37,.71-1.88,3.55,.54,.29,4.82,2.55,1.88-3.55,.37-.71,3.95-7.47,10.4-19.64,3.45-6.52,1.25-2.35,.05-.1,.15-.28,.05-.09,.54-1.02,.21-.39,.2-.38,.97-1.83,.79-1.48,.12-.23,.11-.2,.07-.14,.1-.17,.03-.06,.24-.44,.12-.22,.41-.77,.11-.21,1.36-2.56,.51-.96,4.25-8.03,.07-.14,.32-.6v-.03s.33-.59,.33-.59l1.32-2.49,1.73-3.28,2.16-4.07,.43-.82c.13-.24,.25-.48,.37-.73,.27-.55,.51-1.11,.73-1.68,.18-.44,.34-.89,.49-1.35l.22-.68,.15-.46,.02-.04Z"
      />
      <polygon
        class="cls-740"
        points="429.62 108.54 422.75 108.54 420.3 113.16 419.93 113.87 418.04 117.43 418.59 117.71 423.41 120.27 425.29 116.71 425.66 116.01 429.62 108.54"
      />
      <g>
        <path
          class="cls-375"
          d="M425.66,116.91l-.37-.2-4.82-2.55-.55-.29-.37-.2c-.2-.11-.44-.06-.53,.1l-11.66,22c-.24,.45-.07,1.02,.39,1.26l5.21,2.76c.33,.17,.71,.13,.98-.07,.11-.08,.21-.19,.28-.32l11.66-22c.09-.16-.01-.38-.21-.49Z"
        />
        <path
          class="cls-375"
          d="M447.09,76.05l-.21-.11-4.84-2.56-.52-.27-.27-.14c-.28-.15-.63-.04-.78,.24l-.63,1.19-.24,.44-.2,.37-.55,1.03-.05,.1-.17,.32-.06,.11-1.21,2.29-3.46,6.54-14.21,26.87c-.09,.17,.01,.39,.21,.49l.37,.2,1.29,.68,4.07,2.16,.37,.2c.21,.11,.44,.06,.53-.1l14.21-26.87,3.45-6.53,1-1.9,.05-.09,.14-.27,.3-.57,.54-1.02,.2-.39,.2-.37,.67-1.27c.15-.28,.04-.63-.24-.78Z"
        />
      </g>
    </g>
    <path
      class="cls-703"
      d="M463.4,44.36c-.74,1.39-2.47,1.92-3.86,1.18-1.39-.74-1.92-2.47-1.18-3.86s2.47-1.92,3.86-1.18,1.92,2.47,1.18,3.86Z"
    />
    <path
      class="cls-617"
      d="M462.28,43.77c-.41,.77-1.37,1.07-2.14,.66-.77-.41-1.07-1.37-.66-2.14,.41-.77,1.37-1.07,2.14-.66,.77,.41,1.07,1.37,.66,2.14Z"
    />
  </g>
</template>
<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
